
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("b6QLO", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $ieeJu = parcelRequire("ieeJu");


var $jdv4R = parcelRequire("jdv4R");


var $kb1I3 = parcelRequire("kb1I3");


var $3sXr4 = parcelRequire("3sXr4");

const $79c6915ee8b28dcd$var$messages = (0, $kSwu1.defineMessages)({
    rovoIsThinking: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.rovo-is-thinking",
        defaultMessage: "Rovo is thinking"
    },
    analyzingContent: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.analyzing-content",
        defaultMessage: "Analyzing your content"
    },
    puttingPiecesTogether: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.putting-pieces-together",
        defaultMessage: "Putting the pieces together"
    },
    structuringRemix: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.structuring-remix",
        defaultMessage: "Structuring your remix"
    },
    designingRemix: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.designing-remix",
        defaultMessage: "Designing your remix"
    },
    structuringYourContent: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.structuring-content",
        defaultMessage: "Structuring your content"
    },
    designingYourContent: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.designing-content",
        defaultMessage: "Designing your content"
    },
    addingItAllTogether: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.adding-it-all-together",
        defaultMessage: "Adding it all together"
    },
    applyingFinalTouches: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.applying-final-touches",
        defaultMessage: "Applying the final touches"
    },
    almostDone: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.almost-done",
        defaultMessage: "Almost done"
    }
});
const $79c6915ee8b28dcd$var$rotatingMessagesNonRemixEntrance = (0, $kSwu1.defineMessages)({
    rovoIsImagining: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.rovo-is-imagining",
        defaultMessage: "Rovo is dreaming it up"
    },
    sketchingSomeIdeas: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.sketching-some-ideas",
        defaultMessage: "Sketching ideas"
    },
    mixingTheColors: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.mixing-the-colors",
        defaultMessage: "Mixing colors"
    },
    findingTheRightStyle: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.finding-the-right-style",
        defaultMessage: "Finding the right style"
    },
    bringingItToLife: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.bringing-it-to-life",
        defaultMessage: "Bringing it to life"
    },
    addingTheDetails: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.adding-the-details",
        defaultMessage: "Adding details"
    },
    applyingTheFinalTouches: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.applying-the-final-touches",
        defaultMessage: "Applying final touches"
    },
    almostDone: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.image-almost-done",
        defaultMessage: "Almost done"
    }
});
const $79c6915ee8b28dcd$var$styles = {
    rovoWrapperFixed: "_313842dnbC _0adFHsIZbP _1DCdHidnbC _2XsHFMIZbP _1mT5xdy1CL _0Bm75G5zaO _3OE6xY1Y8M _4ApkO21Y8M _39xV02E6Kk _42Yu6BbFo4",
    rovoWrapperFixedContentCentered: "_1mT5xdy1CL _0Bm75G5zaO _39xV02E6Kk _1VJPcajssS _42Yu6BbFo4",
    parentDetector: "_1mT5xdWVPG _0fKRyPnQyn _1pp6NdYbGa",
    rovoWrapperAbsolute: "_313842dnbC _0adFHsIZbP _1DCdHidnbC _2XsHFMIZbP _1mT5xdWVPG _0Bm75G5zaO _3OE6xY1Y8M _4ApkO21Y8M _39xV02E6Kk _42Yu6BbFo4",
    rovoWrapperRelative: "_1mT5xdRAKS _0Of8r25zaO _1wydGW5zaO"
};
function $79c6915ee8b28dcd$export$d6f2d83daf5efc44({ onStop: onStop, remixAttemptId: remixAttemptId, optionType: _optionType, isRelative: isRelative = false, loadingBarType: loadingBarType = isRelative ? 'mini-bar' : 'big-bar', showProgressBar: showProgressBar = false, isComplete: isComplete = false, onCompleteAnimationFinished: onCompleteAnimationFinished, contentType: contentType, isRemixEntrance: isRemixEntrance = true, shouldMeasureContentBounds: shouldMeasureContentBounds = false }) {
    const loadingBarExperienceInstanceId = (0, $cozmU.useId)();
    const loadingBarMetadataRef = (0, $cozmU.useRef)({
        remixAttemptId: remixAttemptId,
        loadingBarType: loadingBarType,
        contentType: contentType,
        optionType: _optionType,
        isRemixEntrance: isRemixEntrance,
        hasCompletionHandshake: onCompleteAnimationFinished !== undefined
    });
    (0, $cozmU.useEffect)(()=>{
        const loadingBarExperience = (0, $jdv4R.createRemixLoadingBarExperience)(loadingBarExperienceInstanceId);
        loadingBarExperience.start();
        loadingBarExperience.addMetadata(loadingBarMetadataRef.current);
        return ()=>{
            loadingBarExperience.success();
        };
    }, [
        loadingBarExperienceInstanceId
    ]);
    const positionAbsolute = contentType === 'jira.issue'; // Confluence page remix uses the fixed/overlay path (no `contentType`, not `isRelative`).
    // When enabled, center the bar over the content area instead of the viewport so it stays
    // aligned when a sidenav/sidebar is open. Jira (`positionAbsolute`) is unaffected.
    const isCenterContentExpEnabled = (0, $ieeJu.expValEquals)('cc_maui_polish_changes_batch_2', 'isEnabled', true);
    const shouldCenterOnContent = isCenterContentExpEnabled && shouldMeasureContentBounds; // Measure the content container (the detector marker's parent) so the fixed bar can be
    // centered on the content rather than the viewport. Re-measures on container resize, which
    // covers a sidenav/sidebar opening or closing. Stays viewport-centered until measured.
    const parentDetectorRef = (0, $cozmU.useRef)(null);
    const [contentCenterX, setContentCenterX] = (0, $cozmU.useState)(null);
    (0, $cozmU.useEffect)(()=>{
        if (!shouldCenterOnContent) return;
        const parentContainer = parentDetectorRef.current?.parentElement;
        if (!parentContainer) return;
        const updateCenter = ()=>{
            const rect = parentContainer.getBoundingClientRect();
            setContentCenterX(rect.left + rect.width / 2);
        };
        const resizeObserver = new ResizeObserver(updateCenter);
        resizeObserver.observe(parentContainer);
        updateCenter();
        return ()=>resizeObserver.disconnect();
    }, [
        shouldCenterOnContent
    ]);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)(); // A/A experiment paired with cc_maui_create_keyword; called to balance exposures. Result unused.
    (0, $ieeJu.expValEquals)('cc_maui_create_keyword_aa', 'isEnabled', true);
    const thinkingTexts = [
        formatMessage($79c6915ee8b28dcd$var$messages.rovoIsThinking),
        formatMessage($79c6915ee8b28dcd$var$messages.analyzingContent),
        formatMessage($79c6915ee8b28dcd$var$messages.puttingPiecesTogether),
        formatMessage((0, $ieeJu.expValEquals)('cc_maui_create_keyword', 'isEnabled', true) ? $79c6915ee8b28dcd$var$messages.structuringYourContent : $79c6915ee8b28dcd$var$messages.structuringRemix),
        formatMessage((0, $ieeJu.expValEquals)('cc_maui_create_keyword', 'isEnabled', true) ? $79c6915ee8b28dcd$var$messages.designingYourContent : $79c6915ee8b28dcd$var$messages.designingRemix),
        formatMessage($79c6915ee8b28dcd$var$messages.addingItAllTogether),
        formatMessage($79c6915ee8b28dcd$var$messages.applyingFinalTouches),
        formatMessage($79c6915ee8b28dcd$var$messages.almostDone)
    ];
    const thinkingTextsNonRemixEntrance = [
        formatMessage($79c6915ee8b28dcd$var$rotatingMessagesNonRemixEntrance.rovoIsImagining),
        formatMessage($79c6915ee8b28dcd$var$rotatingMessagesNonRemixEntrance.sketchingSomeIdeas),
        formatMessage($79c6915ee8b28dcd$var$rotatingMessagesNonRemixEntrance.mixingTheColors),
        formatMessage($79c6915ee8b28dcd$var$rotatingMessagesNonRemixEntrance.findingTheRightStyle),
        formatMessage($79c6915ee8b28dcd$var$rotatingMessagesNonRemixEntrance.bringingItToLife),
        formatMessage($79c6915ee8b28dcd$var$rotatingMessagesNonRemixEntrance.addingTheDetails),
        formatMessage($79c6915ee8b28dcd$var$rotatingMessagesNonRemixEntrance.applyingTheFinalTouches),
        formatMessage($79c6915ee8b28dcd$var$rotatingMessagesNonRemixEntrance.almostDone)
    ];
    const barContent = /*#__PURE__*/ $cozmU.createElement((0, $3sXr4.RovoThinkingBarWrapper), {
        isThinking: true
    }, /*#__PURE__*/ $cozmU.createElement((0, $kb1I3.RovoThinkingBar), {
        onStop: onStop,
        showProgressBar: showProgressBar,
        isComplete: isComplete,
        onCompleteAnimationFinished: onCompleteAnimationFinished,
        useRotatingTitle: true,
        customRotatingMessages: isRemixEntrance ? thinkingTexts : thinkingTextsNonRemixEntrance
    })); // Content-centered fixed path (Confluence view page, gated + opted in via
    // `shouldMeasureContentBounds`). Renders a hidden marker so the content container can be
    // measured, then centers the fixed bar on the content's horizontal midpoint. Falls back to
    // viewport-centering (`left: 50%`) until the measurement resolves.
    if (!isRelative && !positionAbsolute && shouldCenterOnContent) return /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        ref: parentDetectorRef,
        xcss: $79c6915ee8b28dcd$var$styles.parentDetector,
        testId: "remix-thinking-bar-parent-detector"
    }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $79c6915ee8b28dcd$var$styles.rovoWrapperFixedContentCentered,
        style: {
            minWidth: (0, $iDrrr.fg)('platform_maui_jira_ui_fix') ? 'min(400px, 100%)' : '400px',
            left: contentCenterX != null ? `${contentCenterX}px` : '50%'
        },
        testId: "remix-thinking-bar-gradient-border"
    }, barContent));
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: // eslint-disable-next-line no-nested-ternary
        isRelative ? $79c6915ee8b28dcd$var$styles.rovoWrapperRelative : positionAbsolute ? $79c6915ee8b28dcd$var$styles.rovoWrapperAbsolute : $79c6915ee8b28dcd$var$styles.rovoWrapperFixed,
        style: {
            minWidth: (0, $iDrrr.fg)('platform_maui_jira_ui_fix') ? 'min(400px, 100%)' : '400px'
        },
        testId: "remix-thinking-bar-gradient-border"
    }, barContent);
}
module.exports["RemixThinkingBar"] = $79c6915ee8b28dcd$export$d6f2d83daf5efc44;

});

parcelRegister("jdv4R", function(module, exports) {

var $cNAch = parcelRequire("cNAch");


var $4MiWC = parcelRequire("4MiWC");

const $8d105d30086155d7$export$4be31113674d294a = (instanceId)=>new (0, $cNAch.UFOExperience)('remix-loading-bar', {
        type: (0, $4MiWC.ExperienceTypes).Experience,
        performanceType: (0, $4MiWC.ExperiencePerformanceTypes).InlineResult
    }, instanceId);
module.exports["createRemixLoadingBarExperience"] = $8d105d30086155d7$export$4be31113674d294a;

});

parcelRegister("8GyO5", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $9kbTQ = parcelRequire("9kbTQ");


var $kHija = parcelRequire("kHija");


var $1hQ0e = parcelRequire("1hQ0e");


var $cha5E = parcelRequire("cha5E");


var $2pQiO = parcelRequire("2pQiO");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $1qYXT = parcelRequire("1qYXT");


var $crsgV = parcelRequire("crsgV");


var $b6QLO = parcelRequire("b6QLO");

const $1babe6d267af7ec0$var$randomId = ()=>{
    if (globalThis?.crypto?.randomUUID) return globalThis.crypto.randomUUID();
     // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- uuid is used as a fallback for environments where crypto.randomUUID is unavailable
    return (0, (/*@__PURE__*/$parcel$interopDefault($kHija)))();
};
const $1babe6d267af7ec0$var$styles = {
    anchorTrigger: "_1mT5xdy1CL _1pp6NdYbGa"
}; /**
    * Builds a `RemixPopup` `trigger` render function from a plain DOM rect snapshot: an invisible,
    * fixed-position div matching the rect's bounds, which the popup anchors to. Used for entry points
    * that don't have a persistent trigger element (e.g. a floating/selection toolbar, or a button that
    * may unmount while the flow is active) — they instead capture `getBoundingClientRect()` (or the
    * current selection's rect) once, at click time.
    *
    * Portaled directly to the top-level document body: `RemixContainer` can be mounted anywhere in a product's DOM
    * tree (e.g. deep inside an editor's content component), and `position: fixed` is only viewport-
    * relative when none of its ancestors have a `transform`/`filter`/`will-change` — which editors
    * commonly do for scroll/sticky containers. Portaling avoids inheriting any such ancestor, so the
    * rect is always interpreted relative to the viewport, matching where it was captured.
    */ 
function $1babe6d267af7ec0$var$buildAnchorRectTrigger(anchorRect) {
    return (triggerProps)=>{
        const document = (0, $1hQ0e.getDocument)();
        if (!document?.body) return null;
        return /*#__PURE__*/ (0, $9kbTQ.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            ...triggerProps,
            xcss: $1babe6d267af7ec0$var$styles.anchorTrigger,
            style: {
                top: anchorRect.top,
                left: anchorRect.left,
                width: anchorRect.width,
                height: anchorRect.height
            },
            "aria-hidden": "true"
        }), document.body);
    };
} /**
   * Props for the Remix container composed entry point.
   */ 
function $1babe6d267af7ec0$export$d2a66369b43f5d65({ onClose: onClose, remixAttemptId: remixAttemptId, onOptionSelect: onOptionSelect, onRemixFlowActiveChange: onRemixFlowActiveChange, hideThinkingBar: hideThinkingBar = false, isEphemeralViewVisible: isEphemeralViewVisible = false, skipThinkingTypes: skipThinkingTypes, options: options, hiddenOptions: hiddenOptions, subtitle: subtitle, cascadingMenuHeader: cascadingMenuHeader, presentation: presentation = 'modal', trigger: trigger, anchorRect: anchorRect, popupPlacement: popupPlacement, popupOffset: popupOffset, isPopupOpen: isPopupOpen = true, shouldCloseOnScroll: shouldCloseOnScroll = false, shouldPreserveEditorFocus: shouldPreserveEditorFocus = false, popupRepositionKey: popupRepositionKey, showProgressBar: showProgressBar = false, isComplete: isComplete = false, isThinking: controlledIsThinking, onCompleteAnimationFinished: onCompleteAnimationFinished, contentType: contentType, autoSubmitUserPrompt: autoSubmitUserPrompt, autoSubmitSelection: autoSubmitSelection, onStopThinking: onStopThinking, isRemixEntrance: isRemixEntrance = true, shouldMeasureContentBounds: shouldMeasureContentBounds = false }) {
    // for editor, isThinking will be passed in, which is stored in editor state
    // Auto-submitted prompts/selections should skip the option picker on first render.
    const [localIsThinking, setLocalIsThinking] = (0, $cozmU.useState)(!!autoSubmitUserPrompt || !!autoSubmitSelection);
    const isThinking = controlledIsThinking ?? localIsThinking;
    const [localRemixAttemptId, setLocalRemixAttemptId] = (0, $cozmU.useState)();
    const localRemixAttemptIdRef = (0, $cozmU.useRef)(undefined);
    (0, $cozmU.useEffect)(()=>{
        var _localRemixAttemptIdRef;
        if (!isThinking || remixAttemptId) {
            localRemixAttemptIdRef.current = undefined;
            setLocalRemixAttemptId(undefined);
            return;
        }
        (_localRemixAttemptIdRef = localRemixAttemptIdRef).current ?? (_localRemixAttemptIdRef.current = $1babe6d267af7ec0$var$randomId());
        setLocalRemixAttemptId(localRemixAttemptIdRef.current);
    }, [
        isThinking,
        remixAttemptId
    ]);
    const currentRemixAttemptId = remixAttemptId ?? localRemixAttemptId;
    const [selectedOptionType, setSelectedOptionType] = (0, $cozmU.useState)(); // Prevent the option picker flashing after a cancelled auto-submit flow.
    const [isCancelledAutoSubmit, setIsCancelledAutoSubmit] = (0, $cozmU.useState)(false);
    const showThinkingBar = isThinking && currentRemixAttemptId !== undefined && !isEphemeralViewVisible && !hideThinkingBar;
    const remixMenuCohort = (0, $2pQiO.UNSAFE_expValNoExposure)((0, $1qYXT.REMIX_MENU_EXPERIMENT), (0, $1qYXT.REMIX_MENU_COHORT_PARAM), (0, $1qYXT.REMIX_MENU_CONTROL_COHORT));
    const isDropdownVariantEnabled = remixMenuCohort === (0, $1qYXT.REMIX_MENU_INLINE_DROPDOWN_COHORT);
    const effectiveTrigger = trigger ?? (isDropdownVariantEnabled && anchorRect ? $1babe6d267af7ec0$var$buildAnchorRectTrigger(anchorRect) : undefined);
    const effectivePresentation = isDropdownVariantEnabled && effectiveTrigger ? 'popup' : presentation; // Shared menu-open point for experiment exposure.
    const isRemixMenuOpen = (effectivePresentation !== 'popup' || !effectiveTrigger || isPopupOpen) && !isThinking; // Exposure only; variant behavior is added in follow-up PRs.
    (0, $cozmU.useEffect)(()=>{
        if (!isRemixMenuOpen) return;
        const remixMenuCohort = (0, $cha5E.expVal)((0, $1qYXT.REMIX_MENU_EXPERIMENT), (0, $1qYXT.REMIX_MENU_COHORT_PARAM), (0, $1qYXT.REMIX_MENU_CONTROL_COHORT));
        if (remixMenuCohort === (0, $1qYXT.REMIX_MENU_INLINE_DROPDOWN_COHORT)) ;
        else remixMenuCohort; // Keep the existing A/A exposure logic unchanged.
        (0, $cha5E.expVal)((0, $1qYXT.REMIX_MENU_AA_EXPERIMENT), (0, $1qYXT.REMIX_MENU_AA_VARIANT_PARAM), (0, $1qYXT.REMIX_MENU_CONTROL_COHORT));
    }, [
        isRemixMenuOpen
    ]); // When a selection is pre-supplied (the picker lives elsewhere, e.g. the editor
    // toolbar Remix dropdown), fire it once on mount and never render the in-app
    // picker. This runs even when a controlled `isThinking={false}` is passed.
    const hasAutoSubmittedSelectionRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(false);
    (0, $cozmU.useEffect)(()=>{
        if (hasAutoSubmittedSelectionRef.current || !autoSubmitSelection) return;
        hasAutoSubmittedSelectionRef.current = true;
        setSelectedOptionType(autoSubmitSelection.type);
        setLocalIsThinking(true);
        onRemixFlowActiveChange?.(true);
        onOptionSelect?.(autoSubmitSelection); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        autoSubmitSelection?.type,
        autoSubmitSelection?.subType,
        autoSubmitSelection?.userPrompt
    ]);
    const handleOptionSelect = (0, $cozmU.useCallback)((params)=>{
        if (!skipThinkingTypes?.has(params.type)) setLocalIsThinking(true);
        setSelectedOptionType(params.type);
        onRemixFlowActiveChange?.(true);
        onOptionSelect?.(params);
    }, [
        onOptionSelect,
        onRemixFlowActiveChange,
        skipThinkingTypes
    ]);
    const handleStopThinking = (0, $cozmU.useCallback)(()=>{
        if ((0, $iDrrr.fg)('platform_editor_ai_remix_toolbar')) onStopThinking?.();
        setLocalIsThinking(false);
        if (autoSubmitUserPrompt) setIsCancelledAutoSubmit(true);
         // for insertion, when cancel, the logic is from ProseMirror, we'll show the modal again and
        // - we call onRemixFlowActiveChange in useEffect to cancel the request
        // but for update, when cancel, the logic is from UI, we have to call onRemixFlowActiveChange manually
        // - cause the component tree will be unmounted and the useEffect will not be called
        onRemixFlowActiveChange?.(false);
    }, [
        autoSubmitUserPrompt,
        onRemixFlowActiveChange,
        onStopThinking
    ]); // only when show the thinking bar, we handle the escape key to stop the thinking
    // when the thinking bar is rendered in editor, the escape will also be handled by editor
    (0, $cozmU.useEffect)(()=>{
        if ((0, $iDrrr.fg)('platform_editor_ai_remix_toolbar')) {
            if (!showThinkingBar) return;
        } else {
            if ((0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading')) return;
            if (!isThinking) return;
        }
        return (0, $cbY7C.bind)(window, {
            type: 'keydown',
            listener: (e)=>{
                if (e.key === 'Escape') handleStopThinking();
            }
        });
    }, [
        isThinking,
        handleStopThinking,
        showThinkingBar
    ]); // Keep the trigger mounted so Popup can stay anchored.
    if (effectivePresentation === 'popup' && effectiveTrigger) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $crsgV.RemixPopup), {
        isOpen: isPopupOpen && !isThinking,
        onClose: onClose,
        trigger: effectiveTrigger,
        placement: popupPlacement,
        offset: popupOffset,
        useCascadingMenu: isDropdownVariantEnabled,
        cascadingMenuHeader: cascadingMenuHeader,
        shouldCloseOnScroll: shouldCloseOnScroll,
        shouldPreserveEditorFocus: shouldPreserveEditorFocus,
        onOptionSelect: handleOptionSelect,
        options: options,
        hiddenOptions: hiddenOptions,
        subtitle: subtitle,
        repositionKey: popupRepositionKey
    }), showThinkingBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6QLO.RemixThinkingBar), {
        remixAttemptId: currentRemixAttemptId,
        loadingBarType: "big-bar",
        onStop: handleStopThinking,
        optionType: selectedOptionType,
        showProgressBar: showProgressBar,
        isComplete: isComplete,
        onCompleteAnimationFinished: onCompleteAnimationFinished,
        contentType: contentType,
        isRemixEntrance: isRemixEntrance,
        shouldMeasureContentBounds: shouldMeasureContentBounds
    }));
     // Modal mode (default).
    if (isThinking) {
        if (showThinkingBar) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6QLO.RemixThinkingBar), {
            remixAttemptId: currentRemixAttemptId,
            loadingBarType: "big-bar",
            onStop: handleStopThinking,
            optionType: selectedOptionType,
            showProgressBar: showProgressBar,
            isComplete: isComplete,
            onCompleteAnimationFinished: onCompleteAnimationFinished,
            contentType: contentType,
            isRemixEntrance: isRemixEntrance,
            shouldMeasureContentBounds: shouldMeasureContentBounds
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
    } // Auto-submit cancellation leaves reopening to the caller.
    if (isCancelledAutoSubmit) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
     // Never render the in-app option-picker when a selection is pre-supplied — the
    // picker lives elsewhere (e.g. the editor toolbar Remix dropdown). The mount
    // only exists to run the flow; the auto-submit effect above starts it.
    if (autoSubmitSelection) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $crsgV.RemixOverlay), {
        onClose: onClose,
        onOptionSelect: handleOptionSelect,
        options: options,
        hiddenOptions: hiddenOptions,
        subtitle: subtitle
    });
}
module.exports["RemixContainer"] = $1babe6d267af7ec0$export$d2a66369b43f5d65;

});

parcelRegister("1qYXT", function(module, exports) {
const $f654d7d76017903f$export$dbf8cbce125113dc = 'cc-ce-maui-remix-menu-multivariant';
const $f654d7d76017903f$export$16d917a0604bca11 = 'cc-ce-maui-remix-menu-multivariant-aa';
const $f654d7d76017903f$export$2c70a635cf90671d = 'cohort';
const $f654d7d76017903f$export$1ae578a2cbbda68e = 'variant';
const $f654d7d76017903f$export$3d85c6890e42c40 = 'control';
const $f654d7d76017903f$export$c3c6fd65e75f7a5b = 'variant1';
const $f654d7d76017903f$export$7004846771b000c0 = [
    'mediaSingle',
    'mediaGroup',
    'media',
    'image',
    'extension',
    'bodiedExtension',
    'multiBodiedExtension',
    'embedCard',
    'blockCard',
    'inlineCard',
    // Source blocks
    'bodiedSyncBlock',
    // Reference blocks
    'syncBlock',
    'expand',
    'nestedExpand'
];
const $f654d7d76017903f$var$DENY_SET = new Set($f654d7d76017903f$export$7004846771b000c0);
const $f654d7d76017903f$export$bf9aef57175a93a2 = (nodeType)=>$f654d7d76017903f$var$DENY_SET.has(nodeType);
const $f654d7d76017903f$export$a7b703a84f6e523d = (extensionKey, allowList)=>extensionKey !== undefined && allowList.includes(extensionKey);
module.exports["REMIX_MENU_EXPERIMENT"] = $f654d7d76017903f$export$dbf8cbce125113dc;
module.exports["REMIX_MENU_AA_EXPERIMENT"] = $f654d7d76017903f$export$16d917a0604bca11;
module.exports["REMIX_MENU_COHORT_PARAM"] = $f654d7d76017903f$export$2c70a635cf90671d;
module.exports["REMIX_MENU_AA_VARIANT_PARAM"] = $f654d7d76017903f$export$1ae578a2cbbda68e;
module.exports["REMIX_MENU_CONTROL_COHORT"] = $f654d7d76017903f$export$3d85c6890e42c40;
module.exports["REMIX_MENU_INLINE_DROPDOWN_COHORT"] = $f654d7d76017903f$export$c3c6fd65e75f7a5b;
module.exports["REMIX_DENY_LIST_V1"] = $f654d7d76017903f$export$7004846771b000c0;
module.exports["isRemixRestrictedNodeType"] = $f654d7d76017903f$export$bf9aef57175a93a2;
module.exports["isAllowedMBEExtensionForRemix"] = $f654d7d76017903f$export$a7b703a84f6e523d;

});

parcelRegister("crsgV", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $kSwu1 = parcelRequire("kSwu1");


var $1hQ0e = parcelRequire("1hQ0e");


var $ad7Ou = parcelRequire("ad7Ou");


var $1sCHt = parcelRequire("1sCHt");


var $dTHYM = parcelRequire("dTHYM");


var $I7hWB = parcelRequire("I7hWB");


var $f6cdQ = parcelRequire("f6cdQ");


var $7sJoX = parcelRequire("7sJoX");


var $j6vyT = parcelRequire("j6vyT");


var $lSQgn = parcelRequire("lSQgn");


var $cJ0FD = parcelRequire("cJ0FD");


var $9KSWX = parcelRequire("9KSWX");


var $fEPJS = parcelRequire("fEPJS");


var $7aRdF = parcelRequire("7aRdF");


var $aRGok = parcelRequire("aRGok");


var $2LyZS = parcelRequire("2LyZS");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $4n1IT = parcelRequire("4n1IT");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $hBYtq = parcelRequire("hBYtq");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $e3Wrf = parcelRequire("e3Wrf");


var $ieeJu = parcelRequire("ieeJu");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $lpNn5 = parcelRequire("lpNn5");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $kDDrf = parcelRequire("kDDrf");


var $bjY3F = parcelRequire("bjY3F");


var $HvNsc = parcelRequire("HvNsc");


var $1LRKz = parcelRequire("1LRKz");


var $czfXc = parcelRequire("czfXc");


var $dcNzQ = parcelRequire("dcNzQ");


var $loej8 = parcelRequire("loej8");

const $be6de585ac044839$var$headerOuterStyle = null;
const $be6de585ac044839$var$headerOuterMinimizedStyle = null;
const $be6de585ac044839$var$labsPositionStyle = null;
const $be6de585ac044839$var$headerIconWrapperStyle = null;
const $be6de585ac044839$var$headerIconWrapperMinimizedStyle = null; // 92px = space.300 (24px top padding) + 64px icon + 4px gap
const $be6de585ac044839$var$headerHeadingStyle = null; // left: 16px (space.200) + 48px icon + 8px gap = 72px
// top: vertically centered with 48px icon — icon center is at 16px + 24px = 40px,
// heading line-height ~24px, so top = 40px - 12px = 28px
const $be6de585ac044839$var$headerHeadingMinimizedStyle = null; // 120px = 92px heading top + ~28px heading height
const $be6de585ac044839$var$headerSubtitleStyle = null; // Hide subtitle in minimized state — fast fade out, delayed fade in handled by base style
const $be6de585ac044839$var$headerSubtitleMinimizedStyle = null;
const $be6de585ac044839$var$subtitleStyle = null; // 113px = 64px icon + 4px gap + ~28px heading + ~4px gap + ~13px subtitle
const $be6de585ac044839$var$headerSpacerStyle = null; // 48px = minimized icon height (no subtitle in minimized state)
const $be6de585ac044839$var$headerSpacerMinimizedStyle = null; // ── RemixSubTypeGrid styles ────────────────────────────────────────────────
const $be6de585ac044839$var$gridStyles = {
    grid: "_2mHwu82ADO _3iDTPbgBM8 _2iEGP2PTnU _39xV02N91d _46hvQm2ADO",
    tile: "_0bjKvD8fU6 _4bt5LAnQyn _2WAcuGnQyn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0jFU0VfI2J _0KLXruoI2d _0wOv4Q7zJH _0hPERGjOvk _1eOmH6d1Zr"
}; // ── RemixAccordionOption styles ────────────────────────────────────────────
const $be6de585ac044839$var$accordionStyles = {
    accordionWrapper: "_0bjKvD8fU6 _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _39xV02N91d",
    accordionHeader: "_0bjKvD8fU6 _2V7sgOdnbC _4c065U2ADO _39xV02N91d _0jFU0VpJKa _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuI7V3 _0KLXru66of _0LQT5E8HPE _03SyCP8HPE _0wOv4Q7zJH",
    expandedContent: "_2Y7lL48HPE _0xmtkoPgdg",
    pickForMeWrapper: "_2Y7lL4gVvo _46hvQmgVvo _0xmtkogVvo _22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67 _43nrzT8HPE"
};
const $be6de585ac044839$var$accordionCollapsedStyle = null;
const $be6de585ac044839$var$accordionExpandedStyle = null;
const $be6de585ac044839$var$revealContentStyle = null;
const $be6de585ac044839$var$pickForMeButtonStyle = null; // ── RemixOverlay styles ────────────────────────────────────────────────────
const $be6de585ac044839$var$modalContentWrapperStyle = null; // ── RemixPopup styles ──────────────────────────────────────────────────────
const $be6de585ac044839$var$subtleSlideIn = null;
const $be6de585ac044839$var$popupStyles = {
    popupEnterAnimation: "_1gBibyf9Pz _0nFVCG2HTN _43vdfTdisq _3Y6bKp38c8 _39Ohv4YbGa",
    contentWrapper: "_4bt5LAnQyn _2WAcuGnQyn _0bjKvD8fU6 _3iDTPbQ4SZ _0aFT5vbt8w _39xV02sz7G _0KLXrunmFW",
    cascadingContentWrapper: "_4bt5LAYvD1 _2WAcuGYvD1 _3iDTPbQ4SZ _0aFT5vbt8w _0KLXrujOvk",
    body: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0aFT5vbt8w",
    cascadingBody: "_4bt5LAYvD1 _2WAcuGYvD1 _3iDTPbQ4SZ _0aFT5vbt8w"
};
const $be6de585ac044839$var$transparentPopupContainerStyle = null;
const $be6de585ac044839$var$CascadingPopupContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((props, ref)=>{
    const { shouldRenderToParent: _shouldRenderToParent, shouldFitContainer: _shouldFitContainer, appearance: _appearance, xcss: _xcss, isReferenceHidden: _isReferenceHidden, children: children, 'data-testid': dataTestId, 'data-placement': dataPlacement, ...htmlAttributes } = props;
    const verticalDirection = (0, $dcNzQ.getCascadeVerticalDirectionForPlacement)(dataPlacement);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dcNzQ.CascadeVerticalDirectionContext).Provider, {
        value: verticalDirection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: ref,
        "data-testid": dataTestId ?? 'remix-cascading-popup-container',
        "data-remix-cascading-popup": true,
        "data-toolbar-nested-dropdown-menu": true,
        "data-placement": dataPlacement,
        ...htmlAttributes,
        className: (0, $hekY6.default)([
            "_0KLXrujOvk _2OUyjtYbGa"
        ])
    }, children));
});
$be6de585ac044839$var$CascadingPopupContainer.displayName = 'CascadingPopupContainer';
const $be6de585ac044839$var$scrollableBodyStyle = null;
const $be6de585ac044839$var$remixStyles = {
    describeInputBorderWrapper: "_39xV02N91d _22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67",
    describeInputWrapper: "_4c065U8HPE _2Y7lL45zaO _39xV02N91d _0KLXrunmFW",
    compactDescribeInputWrapper: "_4c065UgVvo _2Y7lL42ADO _39xV02N91d _0KLXruoI2d",
    describePromptRow: "_2mHwu8gVvo _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLz9WS _39xV02N91d",
    describeTextAreaWrapper: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _4ouGXIdnbC",
    modalBodyPadding: "_2Y7lL45zaO _46hvQm1Y8M _0xmtko5zaO",
    remixOptionsStack: "_39xV02N91d"
}; // ── RemixOverlayHeader ─────────────────────────────────────────────────────
function $be6de585ac044839$var$RemixOverlayHeader({ subtitle: subtitle, isMinimized: isMinimized = false }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)(); // A/A experiment paired with cc_maui_create_keyword; called to balance exposures. Result unused.
    (0, $ieeJu.expValEquals)('cc_maui_create_keyword_aa', 'isEnabled', true);
    const subtitleMessage = subtitle ?? (0, $czfXc.default).subtitle; // Track minimized state changes to trigger the icon fade-out/fade-in animation.
    // When isMinimized changes, quickly fade out at the start, then fade back in
    // near the end of the 200ms position transition.
    const iconRef = (0, $cozmU.useRef)(null);
    const prevMinimizedRef = (0, $cozmU.useRef)(isMinimized);
    (0, $cozmU.useEffect)(()=>{
        if (prevMinimizedRef.current !== isMinimized) {
            prevMinimizedRef.current = isMinimized;
            const el = iconRef.current;
            if (el) {
                // Gently fade out (uses the 100ms ease-out opacity transition from the base style)
                el.style.opacity = '0'; // Near the end of the 200ms position transition, fade back in
                const timer = setTimeout(()=>{
                    el.style.opacity = '1';
                }, 130);
                return ()=>clearTimeout(timer);
            }
        }
    }, [
        isMinimized
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_23rrnHTaix _1mT5xdRAKS _39xV02N91d _46hvQmNHnM _0xmtkoNHnM",
            isMinimized && "_46hvQm5zaO _0xmtko5zaO"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: formatMessage((0, $czfXc.default).labsLozengeTooltip),
        position: "top",
        delay: 0
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_1mT5xdWVPG _2IhTon5zaO _4ApkO25zaO _0wOv4Q18ZR _42Yu6B7dHp"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            ...tooltipProps,
            justifyContent: "end"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
            appearance: "discovery"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $czfXc.default).labsLozenge))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: iconRef,
        "aria-hidden": "true",
        className: (0, $hekY6.default)([
            "_23rrnHxGK8 _1mT5xdWVPG _3OE6xY715P _2IhTonNHnM _1VJPcajssS _39xV029LX5 _0jFU0V9LX5",
            isMinimized && "_3OE6xY5zaO _2IhTon5zaO _1VJPcalna5 _39xV02pJKa _0jFU0VpJKa"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($HvNsc))),
        alt: formatMessage((0, $czfXc.default).remixIconAlt),
        width: "100%"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_23rrnHYjhE _1mT5xdWVPG _3OE6xY715P _2IhTonaXQy _1VJPcajssS _1ANEUSLRg7",
            isMinimized && "_3OE6xYUudP _2IhToncM5X _1VJPcalna5"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: isMinimized ? 'medium' : 'large'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $ieeJu.expValEquals)('cc_maui_create_keyword', 'isEnabled', true) ? (0, $czfXc.default).createHeading : (0, $czfXc.default).heading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_23rrnHZWJM _1mT5xdWVPG _3OE6xY715P _2IhTonv6H3 _1VJPcajssS _1ANEUSLRg7",
            isMinimized && "_23rrnH52bh _1YKVNsdnbC _1pp6NdYbGa",
            "_1UtDYzKGUX"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), subtitleMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_23rrnHRiH9 _0jFU0VU9z0",
            isMinimized && "_0jFU0VpJKa"
        ])
    }));
} // ── RemixSubTypeGrid ───────────────────────────────────────────────────────
function $be6de585ac044839$var$RemixSubTypeGrid({ subTypes: subTypes, onSubTypeSelect: onSubTypeSelect }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $be6de585ac044839$var$gridStyles.grid
    }, subTypes.map((subType)=>{
        const IconComponent = (0, $1LRKz.SUB_TYPE_ICON_MAP)[subType.value];
        const label = formatMessage(subType.labelMessage);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            key: subType.value,
            content: label,
            position: "top",
            delay: 0,
            ignoreTooltipPointerEvents: true
        }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                ...tooltipProps,
                xcss: $be6de585ac044839$var$gridStyles.tile,
                onClick: ()=>onSubTypeSelect(subType.value),
                testId: subType.testId,
                "aria-label": label
            }, IconComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(IconComponent, {
                alt: label
            }) : null));
    }));
} // ── RemixAccordionOption ───────────────────────────────────────────────────
const $be6de585ac044839$var$animationConfig = {
    duration: ()=>450
}; // Tracks which option types have already been preloaded to avoid duplicate work.
const $be6de585ac044839$var$preloadedTypes = new Set(); /**
                                                    * Preloads sub-type icon images for a remix option so they display instantly
                                                    * when the accordion expands. Only fetches icons for the active color mode.
                                                    */ 
function $be6de585ac044839$var$preloadSubTypeIcons(option, colorMode) {
    if ($be6de585ac044839$var$preloadedTypes.has(option.type)) return;
    $be6de585ac044839$var$preloadedTypes.add(option.type);
    const isDark = colorMode === 'dark';
    for (const subType of option.subTypes){
        const urls = (0, $1LRKz.SUB_TYPE_ICON_URLS)[subType.value];
        if (urls) {
            const img = new window.Image();
            img.src = isDark ? urls.dark : urls.light;
        }
    }
}
const $be6de585ac044839$var$renderOptionIcon = (option, alt)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
        icon: option.icon,
        label: alt,
        appearance: option.iconTileAppearance ?? 'gray',
        size: "small"
    });
};
function $be6de585ac044839$var$RemixAccordionOption({ option: option, isExpanded: isExpanded, onToggle: onToggle, onSubTypeSelect: onSubTypeSelect, onPickForMe: onPickForMe, colorMode: colorMode }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const smoothResizer = (0, $2LyZS.useResizingHeight)($be6de585ac044839$var$animationConfig);
    const handleToggle = (0, $cozmU.useCallback)(()=>{
        onToggle(option.type);
    }, [
        onToggle,
        option.type
    ]);
    const handleMouseEnter = (0, $cozmU.useCallback)(()=>{
        $be6de585ac044839$var$preloadSubTypeIcons(option, colorMode);
    }, [
        option,
        colorMode
    ]);
    const handleSubTypeSelect = (0, $cozmU.useCallback)((subTypeValue)=>{
        if ((0, $iDrrr.fg)('cc-maui-phase-3')) {
            const subTypeDef = option.subTypes.find((st)=>st.value === subTypeValue);
            onSubTypeSelect(subTypeDef?.emitType ?? option.type, subTypeValue);
            return;
        }
        onSubTypeSelect(option.type, subTypeValue);
    }, [
        onSubTypeSelect,
        option.type,
        option.subTypes
    ]);
    const handlePickForMe = (0, $cozmU.useCallback)(()=>{
        onPickForMe(option.type);
    }, [
        onPickForMe,
        option.type
    ]);
    const ChevronIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))) : (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX)));
    const optionIconAlt = formatMessage(option.iconAltMessage);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            isExpanded ? "_0bjKvD8fU6 _0KLXruoI2d" : "_23rrnHC1jD _0bjKvD8fU6 _0KLXruoI2d _1eOmH6d1Zr _3fSdSTGk8v"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $be6de585ac044839$var$accordionStyles.accordionWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $be6de585ac044839$var$accordionStyles.accordionHeader,
        onClick: handleToggle,
        onMouseEnter: handleMouseEnter,
        testId: option.testId,
        "aria-expanded": isExpanded,
        "aria-label": formatMessage(option.labelMessage)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        gap: "space.100"
    }, $be6de585ac044839$var$renderOptionIcon(option, optionIconAlt), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "medium"
    }, formatMessage(option.labelMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ChevronIcon, {
        label: "",
        color: "var(--ds-icon, #292A2E)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: smoothResizer.ref,
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn"
        ])
    }, isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $be6de585ac044839$var$accordionStyles.expandedContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($be6de585ac044839$var$RemixSubTypeGrid, {
        subTypes: option.subTypes,
        onSubTypeSelect: handleSubTypeSelect
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $be6de585ac044839$var$accordionStyles.pickForMeWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_2mpnYbKxmn _46PhP8u7m9 _2FH9z4N91d"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        spacing: "compact",
        onClick: handlePickForMe,
        testId: `${option.testId}-pick-for-me`
    }, formatMessage((0, $czfXc.default).pickForMe))))))));
}
const $be6de585ac044839$var$RemixFlatOption = ({ option: option, onSelect: onSelect })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleClick = (0, $cozmU.useCallback)(()=>{
        onSelect(option.type);
    }, [
        onSelect,
        option.type
    ]);
    const optionIconAlt = formatMessage(option.iconAltMessage);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_23rrnHC1jD _0bjKvD8fU6 _0KLXruoI2d _1eOmH6d1Zr _3fSdSTGk8v"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $be6de585ac044839$var$accordionStyles.accordionWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $be6de585ac044839$var$accordionStyles.accordionHeader,
        onClick: handleClick,
        testId: option.testId,
        "aria-label": formatMessage(option.labelMessage)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        gap: "space.100"
    }, $be6de585ac044839$var$renderOptionIcon(option, optionIconAlt), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "medium"
    }, formatMessage(option.labelMessage))))));
};
function $be6de585ac044839$var$setRef(ref, value) {
    if (typeof ref === 'function') {
        ref(value);
        return;
    }
    if (ref) ref.current = value;
}
function $be6de585ac044839$var$RemixOpenMenuExperienceTracker() {
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    (0, $cozmU.useEffect)(()=>{
        (0, $kDDrf.succeedRemixOpenMenuExperience)(experienceTracker);
    }, [
        experienceTracker
    ]);
    return null;
} /**
   * Placements supported by the anchored RemixPopup.
   * - 'left-end': contextual object-level entry point (opens to the left).
   * - 'bottom-start': toolbar "Remix" button dropdown (opens downward, aligned to trigger start).
   * - 'bottom-end': toolbar "Remix" button dropdown when the cascade needs left-side room.
   */ 
const $be6de585ac044839$var$stopEditorNativeEvent = (event)=>{
    // Block controls and block-menu hosts install native document/editor listeners before
    // React's delegated handlers. Stop at the textarea DOM boundary so focusing the prompt
    // cannot be interpreted as an outside click. Do not preventDefault: native focus and
    // text editing must continue to work.
    event.stopPropagation();
    event.stopImmediatePropagation();
};
const $be6de585ac044839$var$bindEditorNativeEventListeners = (element)=>(0, $cbY7C.bindAll)(element, [
        {
            type: 'mousedown',
            listener: $be6de585ac044839$var$stopEditorNativeEvent
        },
        {
            type: 'mouseup',
            listener: $be6de585ac044839$var$stopEditorNativeEvent
        },
        {
            type: 'click',
            listener: $be6de585ac044839$var$stopEditorNativeEvent
        }
    ]); /**
      * Suppress the default focus transfer for a press inside the menu. `click` still fires, so option
      * selection works. Text controls are exempt because they must be focusable to be typed into.
      */ 
const $be6de585ac044839$var$preserveFocusOnPress = (event)=>{
    const target = event.target;
    if (target instanceof Element && target.closest('textarea, input, select, [contenteditable="true"]') !== null) return;
    event.preventDefault();
};
const $be6de585ac044839$var$bindPreserveFocusListener = (element)=>(0, $cbY7C.bind)(element, {
        type: 'mousedown',
        listener: $be6de585ac044839$var$preserveFocusOnPress
    });
function $be6de585ac044839$var$RemixDescribeInput({ value: value, onChange: onChange, onSubmit: onSubmit, autoFocus: autoFocus = false, isCompact: isCompact = false }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const describeTextAreaRef = (0, $cozmU.useRef)(null);
    const unbindDescribeInputBoundaryRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (!autoFocus) return;
         // requestAnimationFrame so focus lands after the modal has fully mounted.
        const raf = requestAnimationFrame(()=>{
            describeTextAreaRef.current?.focus();
        });
        return ()=>cancelAnimationFrame(raf);
    }, [
        autoFocus
    ]);
    const setDescribeInputBoundaryRef = (0, $cozmU.useCallback)((element)=>{
        unbindDescribeInputBoundaryRef.current?.();
        unbindDescribeInputBoundaryRef.current = element && isCompact ? $be6de585ac044839$var$bindEditorNativeEventListeners(element) : null;
    }, [
        isCompact
    ]);
    const handleSubmit = (0, $cozmU.useCallback)(()=>{
        if (value?.trim()) onSubmit();
    }, [
        value,
        onSubmit
    ]);
    const handleKeyDown = (0, $cozmU.useCallback)((e)=>{
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSubmit();
        }
    }, [
        handleSubmit
    ]);
    const placeholder = formatMessage((0, $ieeJu.expValEquals)('cc_maui_create_keyword', 'isEnabled', true) ? (0, $czfXc.default).createDescribePlaceholder : (0, $czfXc.default).describePlaceholder);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $be6de585ac044839$var$remixStyles.describeInputBorderWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: isCompact ? setDescribeInputBoundaryRef : undefined,
        xcss: isCompact ? $be6de585ac044839$var$remixStyles.compactDescribeInputWrapper : $be6de585ac044839$var$remixStyles.describeInputWrapper,
        testId: "remix-overlay-describe-input-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dTHYM.default), {
        onSubmit: handleSubmit
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $be6de585ac044839$var$remixStyles.describePromptRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $be6de585ac044839$var$remixStyles.describeTextAreaWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
        ref: describeTextAreaRef,
        appearance: "none",
        placeholder: placeholder,
        value: value,
        onChange: (e)=>onChange(e.currentTarget.value),
        onKeyDown: handleKeyDown,
        isCompact: true,
        minimumRows: 1,
        maxHeight: "200px",
        resize: "smart",
        "aria-label": placeholder,
        testId: "remix-overlay-describe-input",
        name: "remix-overlay-describe"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        type: "submit",
        appearance: "primary",
        isDisabled: !value?.trim(),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($f6cdQ))),
        label: formatMessage((0, $czfXc.default).describeSubmitLabel),
        testId: "remix-overlay-describe-submit"
    })))));
}
function $be6de585ac044839$export$ced6b2e82a17b9f6({ onOptionSelect: onOptionSelect, options: options, hiddenOptions: hiddenOptions, subtitle: subtitle }) {
    // A/A experiment paired with cc_maui_create_keyword; called to balance exposures. Result unused.
    (0, $ieeJu.expValEquals)('cc_maui_create_keyword_aa', 'isEnabled', true);
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    const [describeValue, setDescribeValue] = (0, $cozmU.useState)('');
    const [expandedOption, setExpandedOption] = (0, $cozmU.useState)(null);
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const resolvedOptions = (0, $cozmU.useMemo)(()=>(0, $loej8.getRemixMenuOptions)({
            source: options === undefined ? {
                kind: 'preset',
                preset: 'selection'
            } : {
                kind: 'custom',
                choices: options
            },
            excludedRemixTypes: hiddenOptions ? [
                ...hiddenOptions
            ] : undefined
        }), [
        hiddenOptions,
        options
    ]);
    const handleDescribeSubmit = (0, $cozmU.useCallback)(()=>{
        onOptionSelect?.({
            type: 'custom',
            userPrompt: describeValue
        });
    }, [
        describeValue,
        onOptionSelect
    ]);
    const handleToggle = (0, $cozmU.useCallback)((type)=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'remixOverlaySection',
            attributes: {
                sectionType: type
            }
        });
        setExpandedOption((prev)=>prev === type ? null : type);
    }, [
        sendAnalyticsEvent
    ]);
    const handleSubTypeSelect = (0, $cozmU.useCallback)((type, subType)=>{
        const trimmedDescribe = describeValue?.trim();
        const userPrompt = trimmedDescribe && (0, $4o0zT.isExperimentEnabled)('cc_maui_remix_combine_type_and_prompt') ? trimmedDescribe : undefined;
        onOptionSelect?.({
            type: type,
            subType: subType,
            userPrompt: userPrompt
        });
    }, [
        onOptionSelect,
        describeValue
    ]);
    const handlePickForMe = (0, $cozmU.useCallback)((type)=>{
        onOptionSelect?.({
            type: type
        });
    }, [
        onOptionSelect
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($be6de585ac044839$var$RemixOverlayHeader, {
        subtitle: subtitle,
        isMinimized: expandedOption !== null
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _2WAcuGIZbP"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $be6de585ac044839$var$remixStyles.modalBodyPadding
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100",
        alignInline: "stretch",
        xcss: $be6de585ac044839$var$remixStyles.remixOptionsStack
    }, resolvedOptions.map((option)=>option.subTypes.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($be6de585ac044839$var$RemixAccordionOption, {
            key: option.type,
            option: option,
            isExpanded: expandedOption === option.type,
            onToggle: handleToggle,
            onSubTypeSelect: handleSubTypeSelect,
            onPickForMe: handlePickForMe,
            colorMode: colorMode
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($be6de585ac044839$var$RemixFlatOption, {
            key: option.type,
            option: option,
            onSelect: handlePickForMe
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($be6de585ac044839$var$RemixDescribeInput, {
        value: describeValue,
        onChange: setDescribeValue,
        onSubmit: handleDescribeSubmit,
        autoFocus: true
    }));
} /**
   * RemixOverlay — centered ADS Modal presentation
   */ 
function $be6de585ac044839$export$48a746fedb7ffb({ onClose: onClose, onOptionSelect: onOptionSelect, options: options, hiddenOptions: hiddenOptions, subtitle: subtitle }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
        onClose: onClose,
        width: 320,
        testId: "remix-overlay",
        shouldReturnFocus: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _4bt5LAnQyn _2WAcuGnQyn _0bjKvDOLYo _3iDTPbQ4SZ _0aFT5vbt8w _0KLXrunmFW"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), {
        hasInlinePadding: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($be6de585ac044839$var$RemixOpenMenuExperienceTracker, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($be6de585ac044839$export$ced6b2e82a17b9f6, {
        onOptionSelect: onOptionSelect,
        options: options,
        hiddenOptions: hiddenOptions,
        subtitle: subtitle
    })))));
} /**
   * Calls the Popup `update` function to reposition the popup whenever `repositionKey` changes.
   */ 
function $be6de585ac044839$var$PopupRepositionOnKeyChange({ repositionKey: repositionKey, update: update }) {
    const prevKey = (0, $cozmU.useRef)(repositionKey);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (prevKey.current !== repositionKey) {
            prevKey.current = repositionKey;
            update();
        }
    }, [
        repositionKey,
        update
    ]);
    return null;
} /**
   * RemixPopup — anchored ADS Popup presentation for contextual entry points (e.g. object-level sidebar).
   * No blanket, anchored to a trigger element.
   */ 
function $be6de585ac044839$export$a8b0b54f368ecbb0({ isOpen: isOpen, onClose: onClose, trigger: trigger, onOptionSelect: onOptionSelect, options: options, hiddenOptions: hiddenOptions, subtitle: subtitle, placement: placement = 'left-end', offset: offset = [
    8,
    16
], repositionKey: repositionKey, useCascadingMenu: useCascadingMenu = false, cascadingMenuHeader: cascadingMenuHeader, shouldCloseOnScroll: shouldCloseOnScroll = false, shouldPreserveEditorFocus: shouldPreserveEditorFocus = false }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [cascadeDirection, setCascadeDirection] = (0, $cozmU.useState)('right');
    const [hasMeasuredCascadeDirection, setHasMeasuredCascadeDirection] = (0, $cozmU.useState)(false);
    const [describeValue, setDescribeValue] = (0, $cozmU.useState)('');
    const effectivePlacement = useCascadingMenu && placement === 'bottom-start' && cascadeDirection === 'left' ? 'bottom-end' : placement;
    const popupRepositionKey = useCascadingMenu ? `${repositionKey ?? ''}:${cascadeDirection}` : repositionKey;
    (0, $cozmU.useEffect)(()=>{
        if (!isOpen) {
            setCascadeDirection('right');
            setHasMeasuredCascadeDirection(false);
            setDescribeValue('');
        }
    }, [
        isOpen
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isOpen || !useCascadingMenu || !shouldCloseOnScroll) return;
        const handleScroll = (event)=>{
            const target = event.target;
            if (target instanceof Element && target.closest('[data-remix-cascading-popup]')) return;
            onClose();
        }; // Scroll does not bubble, so capture on window to observe page and nested scroll containers.
        return (0, $cbY7C.bind)(window, {
            type: 'scroll',
            listener: handleScroll,
            options: {
                capture: true
            }
        });
    }, [
        isOpen,
        onClose,
        shouldCloseOnScroll,
        useCascadingMenu
    ]);
    const updateCascadeDirectionFromTrigger = (0, $cozmU.useCallback)((triggerElement)=>{
        if (!useCascadingMenu || !triggerElement || !isOpen) return;
        const document = (0, $1hQ0e.getDocument)();
        const viewportWidth = window.innerWidth || document?.documentElement.clientWidth || 0;
        const nextDirection = (0, $dcNzQ.getCascadeDirectionForAnchor)(triggerElement.getBoundingClientRect(), viewportWidth);
        setCascadeDirection((currentDirection)=>currentDirection === nextDirection ? currentDirection : nextDirection);
        setHasMeasuredCascadeDirection(true);
    }, [
        isOpen,
        useCascadingMenu
    ]);
    const unbindPreserveFocusRef = (0, $cozmU.useRef)(null); // Callback ref so the listener re-attaches when the popup is closed and reopened.
    const setPreserveFocusRef = (0, $cozmU.useCallback)((element)=>{
        unbindPreserveFocusRef.current?.();
        unbindPreserveFocusRef.current = element && shouldPreserveEditorFocus ? $be6de585ac044839$var$bindPreserveFocusListener(element) : null;
    }, [
        shouldPreserveEditorFocus
    ]); // A/A experiment paired with cc_maui_create_keyword; called to balance exposures. Result unused.
    (0, $ieeJu.expValEquals)('cc_maui_create_keyword_aa', 'isEnabled', true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
        isOpen: isOpen,
        popupComponent: useCascadingMenu ? $be6de585ac044839$var$CascadingPopupContainer : undefined,
        onClose: onClose,
        placement: effectivePlacement,
        offset: offset,
        label: formatMessage((0, $ieeJu.expValEquals)('cc_maui_create_keyword', 'isEnabled', true) ? (0, $czfXc.default).createHeading : (0, $czfXc.default).heading),
        role: "dialog",
        content: ({ update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($be6de585ac044839$var$RemixOpenMenuExperienceTracker, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($be6de585ac044839$var$PopupRepositionOnKeyChange, {
                repositionKey: popupRepositionKey,
                update: update
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $be6de585ac044839$var$popupStyles.popupEnterAnimation
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                ref: setPreserveFocusRef,
                "data-editor-remix-inline-dropdown-preserve-focus": shouldPreserveEditorFocus || undefined,
                xcss: useCascadingMenu ? $be6de585ac044839$var$popupStyles.cascadingContentWrapper : $be6de585ac044839$var$popupStyles.contentWrapper,
                testId: "remix-popup"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: useCascadingMenu ? $be6de585ac044839$var$popupStyles.cascadingBody : $be6de585ac044839$var$popupStyles.body
            }, useCascadingMenu ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dcNzQ.RemixCascadingMenuContent), {
                onOptionSelect: onOptionSelect,
                options: options,
                hiddenOptions: hiddenOptions,
                flyoutDirection: cascadeDirection,
                showFlyout: hasMeasuredCascadeDirection,
                renderOptionIcon: $be6de585ac044839$var$renderOptionIcon,
                header: cascadingMenuHeader ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                    space: "space.100",
                    alignInline: "start"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
                    size: "large"
                }, formatMessage(cascadingMenuHeader.title)), cascadingMenuHeader.subtitle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                    size: "small"
                }, formatMessage(cascadingMenuHeader.subtitle)) : null) : undefined,
                footer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($be6de585ac044839$var$RemixDescribeInput, {
                    value: describeValue,
                    isCompact: true,
                    onChange: setDescribeValue,
                    onSubmit: ()=>onOptionSelect?.({
                            type: 'custom',
                            userPrompt: describeValue
                        })
                })
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($be6de585ac044839$export$ced6b2e82a17b9f6, {
                onOptionSelect: onOptionSelect,
                options: options,
                hiddenOptions: hiddenOptions,
                subtitle: subtitle
            }))))),
        trigger: (triggerProps)=>{
            if (!useCascadingMenu) return trigger(triggerProps);
            return trigger({
                ...triggerProps,
                ref: (triggerElement)=>{
                    $be6de585ac044839$var$setRef(triggerProps.ref, triggerElement);
                    updateCascadeDirectionFromTrigger(triggerElement);
                }
            });
        }
    });
}
module.exports["RemixOverlay"] = $be6de585ac044839$export$48a746fedb7ffb;
module.exports["RemixPopup"] = $be6de585ac044839$export$a8b0b54f368ecbb0;

});

parcelRegister("HvNsc", function(module, exports) {
module.exports = new URL("Remix-Illustration.7b8c03b3.svg", import.meta.url).toString();

});

parcelRegister("1LRKz", function(module, exports) {
/* constants.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iDrrr = parcelRequire("iDrrr");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $jdqQM = parcelRequire("jdqQM");


var $a3xS2 = parcelRequire("a3xS2");


var $1qKb1 = parcelRequire("1qKb1");


var $dZaRy = parcelRequire("dZaRy");


var $i6pum = parcelRequire("i6pum");


var $hT2Mn = parcelRequire("hT2Mn");


var $7vmkU = parcelRequire("7vmkU");


var $7K13i = parcelRequire("7K13i");


var $b5QJc = parcelRequire("b5QJc");


var $5QH2j = parcelRequire("5QH2j");


var $g8eHJ = parcelRequire("g8eHJ");


var $aoAJG = parcelRequire("aoAJG");


var $6A6ao = parcelRequire("6A6ao");


var $gg5rm = parcelRequire("gg5rm");


var $av9Cl = parcelRequire("av9Cl");


var $kuWlT = parcelRequire("kuWlT");


var $7mMw3 = parcelRequire("7mMw3");


var $gP7CA = parcelRequire("gP7CA");


var $l0Xml = parcelRequire("l0Xml");


var $h7GLM = parcelRequire("h7GLM");


var $lE1xe = parcelRequire("lE1xe");


var $4VjKY = parcelRequire("4VjKY");


var $7ZPjf = parcelRequire("7ZPjf");


var $5nwSN = parcelRequire("5nwSN");


var $jDDGi = parcelRequire("jDDGi");


var $h4zH8 = parcelRequire("h4zH8");


var $5udvx = parcelRequire("5udvx");


var $glBZK = parcelRequire("glBZK");


var $eCw66 = parcelRequire("eCw66");


var $g5RPh = parcelRequire("g5RPh");


var $iAb2S = parcelRequire("iAb2S");


var $9oYVI = parcelRequire("9oYVI");


var $l1bw1 = parcelRequire("l1bw1");


var $3Mo2w = parcelRequire("3Mo2w");


var $aBRLd = parcelRequire("aBRLd");


var $gpmJ3 = parcelRequire("gpmJ3");


var $aIlia = parcelRequire("aIlia");


var $9WcaJ = parcelRequire("9WcaJ");


var $iGdgz = parcelRequire("iGdgz");


var $8IXk3 = parcelRequire("8IXk3");

const $1624994978f78343$var$iconStyles = null; // Negative margins to counteract the default padding from the Pressable tile component,
// allowing the image icon to extend edge-to-edge within the tile.
const $1624994978f78343$var$edgeToEdgeIconStyles = null;
const $1624994978f78343$var$SubTypeIcon = ({ src: src, srcDark: srcDark, alt: alt })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    const resolvedSrc = colorMode === 'dark' ? srcDark : src;
    return /*#__PURE__*/ $cozmU.createElement("img", {
        src: resolvedSrc,
        alt: alt,
        "aria-hidden": "true",
        className: (0, $hekY6.default)([
            "_39xV02N91d _0jFU0VN91d _00EA0eiObl _3iDTPbvLZJ"
        ])
    });
};
const $1624994978f78343$export$e0452922cbc2989f = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($g5RPh))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($5QH2j))),
        alt: alt
    });
const $1624994978f78343$export$b08434c95e3df48d = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($lE1xe))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($jdqQM))),
        alt: alt
    });
const $1624994978f78343$export$472946dc5493045a = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4VjKY))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($a3xS2))),
        alt: alt
    });
const $1624994978f78343$export$ccba00b0f4d667f3 = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($h4zH8))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($hT2Mn))),
        alt: alt
    });
const $1624994978f78343$export$b86b18d4ddcc0181 = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($aBRLd))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($av9Cl))),
        alt: alt
    });
const $1624994978f78343$export$a95ef668d7975f40 = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5udvx))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($7vmkU))),
        alt: alt
    });
const $1624994978f78343$export$4f7cb0192e7b1016 = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iAb2S))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($g8eHJ))),
        alt: alt
    });
const $1624994978f78343$export$2df60ac16db5f072 = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jDDGi))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($i6pum))),
        alt: alt
    });
const $1624994978f78343$export$77864082aab0bbe3 = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($l1bw1))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($6A6ao))),
        alt: alt
    });
const $1624994978f78343$export$6fa49d5d85aab725 = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7ZPjf))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($1qKb1))),
        alt: alt
    });
const $1624994978f78343$export$b8c6412fcf2fe65d = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9WcaJ))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($gP7CA))),
        alt: alt
    });
const $1624994978f78343$export$73f1bfda08325f1c = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($aIlia))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($7mMw3))),
        alt: alt
    });
const $1624994978f78343$export$1968847f71768cdf = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9oYVI))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($aoAJG))),
        alt: alt
    });
const $1624994978f78343$var$CorporateDoodleIcon = (props)=>(0, $iDrrr.fg)('cc-maui-phase-2') ? /*#__PURE__*/ $cozmU.createElement($1624994978f78343$export$73f1bfda08325f1c, props) : /*#__PURE__*/ $cozmU.createElement($1624994978f78343$export$b8c6412fcf2fe65d, props);
const $1624994978f78343$export$c02ff6805d67acb2 = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5nwSN))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($dZaRy))),
        alt: alt
    });
const $1624994978f78343$export$368b8c86d4677a50 = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gpmJ3))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($kuWlT))),
        alt: alt
    });
const $1624994978f78343$export$23e94ddbc9d88fae = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8IXk3))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($h7GLM))),
        alt: alt
    });
const $1624994978f78343$export$e5aa73ddcf9d62e8 = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iGdgz))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($l0Xml))),
        alt: alt
    });
const $1624994978f78343$export$a18ea9af6c181602 = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($glBZK))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($7K13i))),
        alt: alt
    });
const $1624994978f78343$export$84442c0324e009f8 = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3Mo2w))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($gg5rm))),
        alt: alt
    });
const $1624994978f78343$var$ImageIcon = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_313842A17z _0adFHsmW1D _1DCdHiA17z _2XsHFMmW1D"
        ])
    }, /*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eCw66))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($b5QJc))),
        alt: alt
    }));
const $1624994978f78343$export$65d7e4b11d55029 = {
    // Charts
    'line-chart': {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($g5RPh))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($5QH2j)))
    },
    'area-chart': {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($lE1xe))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($jdqQM)))
    },
    'bar-chart': {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($4VjKY))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($a3xS2)))
    },
    'funnel-chart': {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($h4zH8))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($hT2Mn)))
    },
    'pie-chart': {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($aBRLd))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($av9Cl)))
    },
    'gantt-chart': {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($5udvx))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($7vmkU)))
    },
    // Diagrams
    mindmap: {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($iAb2S))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($g8eHJ)))
    },
    flowchart: {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($jDDGi))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($i6pum)))
    },
    // Infographics
    'corporate-modern': {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($l1bw1))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($6A6ao)))
    },
    'corporate-doodle': {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($aIlia))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($7mMw3)))
    },
    charlie: {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($7ZPjf))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($1qKb1)))
    },
    minimalist: {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($9oYVI))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($aoAJG)))
    },
    // Visual aids
    'flip-card': {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($5nwSN))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($dZaRy)))
    },
    quadrant: {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($gpmJ3))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($kuWlT)))
    },
    'tree-map': {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($8IXk3))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($h7GLM)))
    },
    'horizontal-timeline': {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($iGdgz))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($l0Xml)))
    },
    map: {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($glBZK))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($7K13i)))
    },
    'org-chart': {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($3Mo2w))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($gg5rm)))
    },
    image: {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($eCw66))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($b5QJc)))
    }
};
const $1624994978f78343$export$ebd45e32b7708bfa = {
    // Charts
    'line-chart': $1624994978f78343$export$e0452922cbc2989f,
    'area-chart': $1624994978f78343$export$b08434c95e3df48d,
    'bar-chart': $1624994978f78343$export$472946dc5493045a,
    'funnel-chart': $1624994978f78343$export$ccba00b0f4d667f3,
    'pie-chart': $1624994978f78343$export$b86b18d4ddcc0181,
    'gantt-chart': $1624994978f78343$export$a95ef668d7975f40,
    // Diagrams
    mindmap: $1624994978f78343$export$4f7cb0192e7b1016,
    flowchart: $1624994978f78343$export$2df60ac16db5f072,
    // Infographics
    'corporate-modern': $1624994978f78343$export$77864082aab0bbe3,
    'corporate-doodle': $1624994978f78343$var$CorporateDoodleIcon,
    charlie: $1624994978f78343$export$6fa49d5d85aab725,
    minimalist: $1624994978f78343$export$1968847f71768cdf,
    // Visual aids
    'flip-card': $1624994978f78343$export$c02ff6805d67acb2,
    quadrant: $1624994978f78343$export$368b8c86d4677a50,
    'tree-map': $1624994978f78343$export$23e94ddbc9d88fae,
    'horizontal-timeline': $1624994978f78343$export$e5aa73ddcf9d62e8,
    map: $1624994978f78343$export$a18ea9af6c181602,
    'org-chart': $1624994978f78343$export$84442c0324e009f8,
    image: $1624994978f78343$var$ImageIcon
};
module.exports["SUB_TYPE_ICON_URLS"] = $1624994978f78343$export$65d7e4b11d55029;
module.exports["SUB_TYPE_ICON_MAP"] = $1624994978f78343$export$ebd45e32b7708bfa;

});

parcelRegister("jdqQM", function(module, exports) {
module.exports = new URL("area-chart.55f6e465.svg", import.meta.url).toString();

});

parcelRegister("a3xS2", function(module, exports) {
module.exports = new URL("bar-chart.fd78c047.svg", import.meta.url).toString();

});

parcelRegister("1qKb1", function(module, exports) {
module.exports = new URL("bold.49b06ac8.svg", import.meta.url).toString();

});

parcelRegister("dZaRy", function(module, exports) {
module.exports = new URL("flip-cards.5ca8ff0a.svg", import.meta.url).toString();

});

parcelRegister("i6pum", function(module, exports) {
module.exports = new URL("flowchart.be00d296.svg", import.meta.url).toString();

});

parcelRegister("hT2Mn", function(module, exports) {
module.exports = new URL("funnel-chart.c5c5ee8c.svg", import.meta.url).toString();

});

parcelRegister("7vmkU", function(module, exports) {
module.exports = new URL("gantt-chart.a8acacb3.svg", import.meta.url).toString();

});

parcelRegister("7K13i", function(module, exports) {
module.exports = new URL("geographical-map.8aed36b5.svg", import.meta.url).toString();

});

parcelRegister("b5QJc", function(module, exports) {
module.exports = new URL("image-option-dark.4ef2b9c9.png", import.meta.url).toString();

});

parcelRegister("5QH2j", function(module, exports) {
module.exports = new URL("line-chart.170f1aac.svg", import.meta.url).toString();

});

parcelRegister("g8eHJ", function(module, exports) {
module.exports = new URL("mindmap.3d2ae695.svg", import.meta.url).toString();

});

parcelRegister("aoAJG", function(module, exports) {
module.exports = new URL("minimalist.5f043ef2.svg", import.meta.url).toString();

});

parcelRegister("6A6ao", function(module, exports) {
module.exports = new URL("modern.b9c52e72.svg", import.meta.url).toString();

});

parcelRegister("gg5rm", function(module, exports) {
module.exports = new URL("org-chart.4294f091.svg", import.meta.url).toString();

});

parcelRegister("av9Cl", function(module, exports) {
module.exports = new URL("pie-chart.51f3bebf.svg", import.meta.url).toString();

});

parcelRegister("kuWlT", function(module, exports) {
module.exports = new URL("quadrant.199f7d1e.svg", import.meta.url).toString();

});

parcelRegister("7mMw3", function(module, exports) {
module.exports = new URL("sketch-v2.ed2b7bb9.svg", import.meta.url).toString();

});

parcelRegister("gP7CA", function(module, exports) {
module.exports = new URL("sketch.e9357258.svg", import.meta.url).toString();

});

parcelRegister("l0Xml", function(module, exports) {
module.exports = new URL("timeline.6ae6674b.svg", import.meta.url).toString();

});

parcelRegister("h7GLM", function(module, exports) {
module.exports = new URL("treemap.1a39a30f.svg", import.meta.url).toString();

});

parcelRegister("lE1xe", function(module, exports) {
module.exports = new URL("area-chart.5c4ca07f.svg", import.meta.url).toString();

});

parcelRegister("4VjKY", function(module, exports) {
module.exports = new URL("bar-chart.958c9357.svg", import.meta.url).toString();

});

parcelRegister("7ZPjf", function(module, exports) {
module.exports = new URL("bold.c47d431b.svg", import.meta.url).toString();

});

parcelRegister("5nwSN", function(module, exports) {
module.exports = new URL("flip-cards.429027cc.svg", import.meta.url).toString();

});

parcelRegister("jDDGi", function(module, exports) {
module.exports = new URL("flowchart.77339b70.svg", import.meta.url).toString();

});

parcelRegister("h4zH8", function(module, exports) {
module.exports = new URL("funnel-chart.12ecbc63.svg", import.meta.url).toString();

});

parcelRegister("5udvx", function(module, exports) {
module.exports = new URL("gantt-chart.1c11810d.svg", import.meta.url).toString();

});

parcelRegister("glBZK", function(module, exports) {
module.exports = new URL("geographical-map.ac5f4483.svg", import.meta.url).toString();

});

parcelRegister("eCw66", function(module, exports) {
module.exports = new URL("image-option.51f3f511.png", import.meta.url).toString();

});

parcelRegister("g5RPh", function(module, exports) {
module.exports = new URL("line-chart.57ecd877.svg", import.meta.url).toString();

});

parcelRegister("iAb2S", function(module, exports) {
module.exports = new URL("mindmap.d452b507.svg", import.meta.url).toString();

});

parcelRegister("9oYVI", function(module, exports) {
module.exports = new URL("minimalist.cbf91eb3.svg", import.meta.url).toString();

});

parcelRegister("l1bw1", function(module, exports) {
module.exports = new URL("modern.4ca836a7.svg", import.meta.url).toString();

});

parcelRegister("3Mo2w", function(module, exports) {
module.exports = new URL("org-chart.694f44ab.svg", import.meta.url).toString();

});

parcelRegister("aBRLd", function(module, exports) {
module.exports = new URL("pie-chart.0477082d.svg", import.meta.url).toString();

});

parcelRegister("gpmJ3", function(module, exports) {
module.exports = new URL("quadrant.5175de07.svg", import.meta.url).toString();

});

parcelRegister("aIlia", function(module, exports) {
module.exports = new URL("sketch-v2.a5dc9d56.svg", import.meta.url).toString();

});

parcelRegister("9WcaJ", function(module, exports) {
module.exports = new URL("sketch.66d6c571.svg", import.meta.url).toString();

});

parcelRegister("iGdgz", function(module, exports) {
module.exports = new URL("timeline.3d28aa4e.svg", import.meta.url).toString();

});

parcelRegister("8IXk3", function(module, exports) {
module.exports = new URL("treemap.1a39a30f.svg", import.meta.url).toString();

});

parcelRegister("czfXc", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $b0a9658e5a4289f5$var$messages = (0, $kSwu1.defineMessages)({
    // ── Header ──────────────────────────────────────────────────────────────
    heading: {
        id: "malleable-ui-components.remix.heading",
        defaultMessage: "Remix"
    },
    createHeading: {
        id: "malleable-ui-components.remix.create-heading",
        defaultMessage: "Create"
    },
    subtitle: {
        id: "malleable-ui-components.remix.subtitle",
        defaultMessage: "View this content in a new form"
    },
    labsLozenge: {
        id: "malleable-ui-components.remix.labs-lozenge.updated",
        defaultMessage: "Labs"
    },
    labsLozengeTooltip: {
        id: "malleable-ui-components.remix.option.lozenge-tooltip",
        defaultMessage: "Beta: This feature is still in development."
    },
    remixIconAlt: {
        id: "malleable-ui-components.remix.icon-alt",
        defaultMessage: "Remix icon"
    },
    // ── Describe input ─────────────────────────────────────────────────────
    describePlaceholder: {
        id: "malleable-ui-components.remix.describe-placeholder",
        defaultMessage: "Or describe your remix..."
    },
    createDescribePlaceholder: {
        id: "malleable-ui-components.remix.create-describe-placeholder",
        defaultMessage: "Or create something else\u2026"
    },
    describeSubmitLabel: {
        id: "malleable-ui-components.remix.describe-submit-label",
        defaultMessage: "Submit"
    },
    // ── Top-level option labels ────────────────────────────────────────────
    remixOptionChart: {
        id: "malleable-ui-components.remix.option.chart",
        defaultMessage: "Charts"
    },
    remixOptionDiagram: {
        id: "malleable-ui-components.remix.option.diagram",
        defaultMessage: "Diagrams"
    },
    remixOptionInfographic: {
        id: "malleable-ui-components.remix.option.infographic",
        defaultMessage: "Infographics"
    },
    remixOptionVisualization: {
        id: "malleable-ui-components.remix.option.visualization",
        defaultMessage: "Visualizations"
    },
    // ── Top-level option icon alts ─────────────────────────────────────────
    chartIconAlt: {
        id: "malleable-ui-components.remix.option.chart-icon-alt",
        defaultMessage: "Chart icon"
    },
    diagramIconAlt: {
        id: "malleable-ui-components.remix.option.diagram-icon-alt",
        defaultMessage: "Diagram icon"
    },
    infographicIconAlt: {
        id: "malleable-ui-components.remix.option.infographic-icon-alt",
        defaultMessage: "Infographic icon"
    },
    visualizationIconAlt: {
        id: "malleable-ui-components.remix.option.visualization-icon-alt",
        defaultMessage: "Visualization icon"
    },
    // ── Top-level option tooltips ──────────────────────────────────────────
    chartTooltip: {
        id: "malleable-ui-components.remix.option.chart-tooltip",
        defaultMessage: "View your data as a chart or graph"
    },
    diagramTooltip: {
        id: "malleable-ui-components.remix.option.diagram-tooltip",
        defaultMessage: "Show relationships with a diagram"
    },
    infographicTooltip: {
        id: "malleable-ui-components.remix.option.infographic-tooltip",
        defaultMessage: "Summarize key points with an infographic"
    },
    visualizationTooltip: {
        id: "malleable-ui-components.remix.option.visualization-tooltip",
        defaultMessage: "Bring your content to life with a bespoke visual"
    },
    // ── Sub-type labels (charts) ───────────────────────────────────────────
    subTypeLineChart: {
        id: "malleable-ui-components.remix.sub-type.line-chart",
        defaultMessage: "Line chart"
    },
    subTypeAreaChart: {
        id: "malleable-ui-components.remix.sub-type.area-chart",
        defaultMessage: "Area chart"
    },
    subTypeBarChart: {
        id: "malleable-ui-components.remix.sub-type.bar-chart",
        defaultMessage: "Bar chart"
    },
    subTypeFunnelChart: {
        id: "malleable-ui-components.remix.sub-type.funnel-chart",
        defaultMessage: "Funnel chart"
    },
    subTypePieChart: {
        id: "malleable-ui-components.remix.sub-type.pie-chart",
        defaultMessage: "Pie chart"
    },
    subTypeGanttChart: {
        id: "malleable-ui-components.remix.sub-type.gantt-chart",
        defaultMessage: "Gantt chart"
    },
    // ── Sub-type labels (diagrams) ─────────────────────────────────────────
    subTypeMindMap: {
        id: "malleable-ui-components.remix.sub-type.mind-map",
        defaultMessage: "Mindmap"
    },
    subTypeFlowChart: {
        id: "malleable-ui-components.remix.sub-type.flow-chart",
        defaultMessage: "Flowchart"
    },
    // ── Sub-type labels (infographics) ─────────────────────────────────────
    subTypeModernStyle: {
        id: "malleable-ui-components.remix.sub-type.modern-style",
        defaultMessage: "Modern style"
    },
    subTypeBoldStyle: {
        id: "malleable-ui-components.remix.sub-type.bold-style",
        defaultMessage: "Bold style"
    },
    subTypeSketchStyle: {
        id: "malleable-ui-components.remix.sub-type.sketch-style",
        defaultMessage: "Sketch style"
    },
    subTypeMinimalistStyle: {
        id: "malleable-ui-components.remix.sub-type.minimalist-style",
        defaultMessage: "Minimalist style"
    },
    // ── Sub-type labels (visual aids) ──────────────────────────────────────
    subTypeFlipCard: {
        id: "malleable-ui-components.remix.sub-type.flip-card",
        defaultMessage: "Flip card"
    },
    subTypeQuadrant: {
        id: "malleable-ui-components.remix.sub-type.quadrant",
        defaultMessage: "Quadrant"
    },
    subTypeTreeMap: {
        id: "malleable-ui-components.remix.sub-type.tree-map",
        defaultMessage: "Tree map"
    },
    subTypeTimeline: {
        id: "malleable-ui-components.remix.sub-type.timeline",
        defaultMessage: "Timeline"
    },
    subTypeGeographicalMap: {
        id: "malleable-ui-components.remix.sub-type.geographical-map",
        defaultMessage: "Geographical map"
    },
    subTypeOrgChart: {
        id: "malleable-ui-components.remix.sub-type.org-chart",
        defaultMessage: "Org chart"
    },
    subTypeImage: {
        id: "malleable-ui-components.remix.sub-type.image",
        defaultMessage: "Image"
    },
    pageRemixSubtitle: {
        id: "malleable-ui-components.remix.page-remix-subtitle",
        defaultMessage: "Create content inspired by this work"
    },
    pageContentGroupLabel: {
        id: "malleable-ui-components.remix.page-content-group-label",
        defaultMessage: "Confluence content"
    },
    remixOptionSlides: {
        id: "malleable-ui-components.remix.option.slides",
        defaultMessage: "Slides"
    },
    remixOptionWhiteboard: {
        id: "malleable-ui-components.remix.option.whiteboard",
        defaultMessage: "Whiteboard"
    },
    remixOptionDatabase: {
        id: "malleable-ui-components.remix.option.database",
        defaultMessage: "Database"
    },
    slidesIconAlt: {
        id: "malleable-ui-components.remix.option.slides-icon-alt",
        defaultMessage: "Slides icon"
    },
    whiteboardIconAlt: {
        id: "malleable-ui-components.remix.option.whiteboard-icon-alt",
        defaultMessage: "Whiteboard icon"
    },
    databaseIconAlt: {
        id: "malleable-ui-components.remix.option.database-icon-alt",
        defaultMessage: "Database icon"
    },
    slidesTooltip: {
        id: "malleable-ui-components.remix.option.slides-tooltip",
        defaultMessage: "Transform your page into a slide deck"
    },
    whiteboardTooltip: {
        id: "malleable-ui-components.remix.option.whiteboard-tooltip",
        defaultMessage: "Visualize your page on a whiteboard"
    },
    databaseTooltip: {
        id: "malleable-ui-components.remix.option.database-tooltip",
        defaultMessage: "Structure your page content as a database"
    },
    // ── Pick for me ────────────────────────────────────────────────────────
    pickForMe: {
        id: "malleable-ui-components.remix.pick-for-me",
        defaultMessage: "Pick for me"
    },
    auto: {
        id: "malleable-ui-components.remix.remix-overlay.auto",
        defaultMessage: "Auto"
    },
    pickForMeTooltip: {
        id: "malleable-ui-components.remix.remix-overlay.pickForMeTooltip",
        defaultMessage: "Pick a style for me"
    },
    // ── Unused legacy keys kept for i18n backwards compat ──────────────────
    selectedContent: {
        id: "malleable-ui-components.remix.selected-content",
        defaultMessage: "Selected content"
    },
    noContent: {
        id: "malleable-ui-components.remix.no-content",
        defaultMessage: "No content selected"
    }
});
var $b0a9658e5a4289f5$export$2e2bcd8739ae039 = $b0a9658e5a4289f5$var$messages;
module.exports["default"] = $b0a9658e5a4289f5$export$2e2bcd8739ae039;

});

parcelRegister("dcNzQ", function(module, exports) {
/* remix-cascading-menu.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $aDSIl = parcelRequire("aDSIl");


var $9d7Pd = parcelRequire("9d7Pd");


var $6IL1T = parcelRequire("6IL1T");


var $8FgJC = parcelRequire("8FgJC");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $1LRKz = parcelRequire("1LRKz");


var $czfXc = parcelRequire("czfXc");


var $loej8 = parcelRequire("loej8");

const $53abef11e3c2aac8$export$d7cf732af02b8895 = /*#__PURE__*/ (0, $cozmU.createContext)('down');
function $53abef11e3c2aac8$export$2ba0f43a8fa8308d(placement) {
    return placement?.startsWith('top') ? 'up' : 'down';
} // Width of a menu column (top-level categories and sub-type submenu).
const $53abef11e3c2aac8$var$CATEGORY_WIDTH = 240;
const $53abef11e3c2aac8$var$SUBTYPE_WIDTH = 160;
const $53abef11e3c2aac8$var$PREVIEW_WIDTH = 176;
const $53abef11e3c2aac8$var$PREVIEW_HEIGHT = 128;
const $53abef11e3c2aac8$var$CASCADE_COLUMN_GAP = 6;
const $53abef11e3c2aac8$var$CASCADE_VIEWPORT_MARGIN = 8;
const $53abef11e3c2aac8$var$CASCADE_FLYOUT_WIDTH = $53abef11e3c2aac8$var$SUBTYPE_WIDTH + $53abef11e3c2aac8$var$PREVIEW_WIDTH + $53abef11e3c2aac8$var$CASCADE_COLUMN_GAP * 2;
function $53abef11e3c2aac8$export$a1ba6991d30166a0(anchorRect, viewportWidth) {
    const fullCascadeWidth = $53abef11e3c2aac8$var$CATEGORY_WIDTH + $53abef11e3c2aac8$var$CASCADE_FLYOUT_WIDTH;
    const availableRightForFullCascade = viewportWidth - anchorRect.left - $53abef11e3c2aac8$var$CASCADE_VIEWPORT_MARGIN;
    const availableLeftForFlyout = anchorRect.left - $53abef11e3c2aac8$var$CASCADE_VIEWPORT_MARGIN;
    return availableRightForFullCascade < fullCascadeWidth && availableLeftForFlyout >= $53abef11e3c2aac8$var$CASCADE_FLYOUT_WIDTH ? 'left' : 'right';
}
const $53abef11e3c2aac8$var$subtleSlideIn = null;
const $53abef11e3c2aac8$var$menuStyles = {
    popupEnterAnimation: "_1gBibyf9Pz _0nFVCG2HTN _43vdfTdisq _3Y6bKp38c8 _39Ohv4YbGa",
    rootRightDown: "_2mHwu8gVvo _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLchRC",
    rootLeftDown: "_2mHwu8gVvo _3iDTPbQ4SZ _0aFT5vf5Xk _0hPCNLchRC",
    rootRightUp: "_2mHwu8gVvo _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLz9WS",
    rootLeftUp: "_2mHwu8gVvo _3iDTPbQ4SZ _0aFT5vf5Xk _0hPCNLz9WS",
    categoryColumn: "_2O5VijdnbC _3YEZNOdnbC _1bHrqEIZbP _4bt5LAnQyn _2WAcuGnQyn _0bjKvD8fU6 _39xV02GVdc _3iDTPbQ4SZ _0aFT5vbt8w _0KLXruoI2d _2OUyjtGk8v",
    categoryHeader: "_46hvQm5zaO _0xmtko2ADO _0LQT5E5zaO _03SyCP5zaO",
    subTypeColumn: "_2O5VijdnbC _3YEZNOdnbC _1bHrqEIZbP _4bt5LAnQyn _2WAcuGnQyn _0bjKvD8fU6 _39xV02oaux _0KLXruoI2d _2OUyjtGk8v",
    previewColumnRight: "_2O5VijdnbC _3YEZNOdnbC _1bHrqEIZbP _4bt5LAnQyn _2WAcuGnQyn _0bjKvD8fU6 _39xV02Jgqs _0jFU0VNNui _4xdlr0IZbP _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _46hvQm2ADO _0xmtko2ADO _0LQT5E2ADO _03SyCP2ADO _24h04i2Njc _0KLXruoI2d _2OUyjtGk8v _1kOSYtC67X _3Z9K0wb8VS _0qk6IKdisq _1SdfoHYbGa",
    previewColumnLeft: "_2O5VijdnbC _3YEZNOdnbC _1bHrqEIZbP _4bt5LAnQyn _2WAcuGnQyn _0bjKvD8fU6 _39xV02Jgqs _0jFU0VNNui _4xdlr0IZbP _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _46hvQm2ADO _0xmtko2ADO _0LQT5E2ADO _03SyCP2ADO _24h04i2Njc _0KLXruoI2d _2OUyjtGk8v _1kOSYtC67X _3Z9K0wb8VS _0qk6IKdisq _1SdfoHYbGa",
    categoryTrailing: "_3iDTPbQ4SZ _0hPCNLDIqT",
    previewContent: "_39xV02N91d _0jFU0VN91d _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _1pp6NdYbGa"
};
function $53abef11e3c2aac8$var$RemixSubTypeColumn({ subTypes: subTypes, categoryOffset: categoryOffset, pickForMeTestId: pickForMeTestId, onSubTypeSelect: onSubTypeSelect, onPickForMe: onPickForMe, onClearPreview: onClearPreview, onHoverSubType: onHoverSubType }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const verticalDirection = (0, $cozmU.useContext)($53abef11e3c2aac8$export$d7cf732af02b8895);
    const columnRef = (0, $cozmU.useRef)(null);
    const handleHoverSubType = (0, $cozmU.useCallback)((subTypeValue, rowElement)=>{
        const columnElement = columnRef.current;
        const rootElement = columnElement?.parentElement;
        if (!columnElement || !rootElement) {
            onHoverSubType(subTypeValue, {
                blockStart: 0,
                blockEnd: 0
            });
            return;
        }
        const rootRect = rootElement.getBoundingClientRect();
        const rowRect = rowElement.getBoundingClientRect();
        const rowMidpoint = rowRect.top + rowRect.height / 2;
        const previewHalfHeight = $53abef11e3c2aac8$var$PREVIEW_HEIGHT / 2; // Keep the preview's midpoint exactly aligned with the subtype row midpoint. These
        // offsets intentionally remain unclamped so edge-row previews may extend beyond the
        // subtype card instead of being pushed off-center.
        const blockStart = rowMidpoint - rootRect.top - previewHalfHeight;
        const blockEnd = rootRect.bottom - rowMidpoint - previewHalfHeight;
        onHoverSubType(subTypeValue, {
            blockStart: blockStart,
            blockEnd: blockEnd
        });
    }, [
        onHoverSubType
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        ref: columnRef,
        xcss: $53abef11e3c2aac8$var$menuStyles.subTypeColumn,
        style: {
            transform: `translateY(${verticalDirection === 'up' ? -categoryOffset.blockEnd : categoryOffset.blockStart}px)`
        },
        testId: "remix-menu-submenu"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $53abef11e3c2aac8$var$menuStyles.popupEnterAnimation
    }, /*#__PURE__*/ $cozmU.createElement((0, $6IL1T.default), null, /*#__PURE__*/ $cozmU.createElement((0, $8FgJC.default), null, subTypes.map((subType)=>{
        const label = formatMessage(subType.labelMessage);
        return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            key: subType.value,
            testId: `remix-menu-subtype-row-${subType.value}`,
            onMouseEnter: (event)=>handleHoverSubType(subType.value, event.currentTarget),
            onFocus: (event)=>handleHoverSubType(subType.value, event.currentTarget)
        }, /*#__PURE__*/ $cozmU.createElement((0, $9d7Pd.default), {
            testId: subType.testId ?? `remix-menu-subtype-${subType.value}`,
            onClick: ()=>onSubTypeSelect(subType.value)
        }, label));
    }))), /*#__PURE__*/ $cozmU.createElement((0, $6IL1T.default), {
        spacing: "compact"
    }, /*#__PURE__*/ $cozmU.createElement((0, $8FgJC.default), {
        hasSeparator: true
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        onMouseEnter: onClearPreview,
        onFocus: onClearPreview
    }, /*#__PURE__*/ $cozmU.createElement((0, $9d7Pd.default), {
        testId: pickForMeTestId,
        onClick: onPickForMe
    }, formatMessage((0, $czfXc.default).pickForMe)))))));
}
function $53abef11e3c2aac8$var$RemixPreviewColumn({ subType: subType, direction: direction, previewOffset: previewOffset }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const verticalDirection = (0, $cozmU.useContext)($53abef11e3c2aac8$export$d7cf732af02b8895);
    const IconComponent = subType && subType.value in (0, $1LRKz.SUB_TYPE_ICON_MAP) ? (0, $1LRKz.SUB_TYPE_ICON_MAP)[subType.value] : null;
    if (!IconComponent || !subType) return null;
    const label = formatMessage(subType.labelMessage);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: direction === 'left' ? $53abef11e3c2aac8$var$menuStyles.previewColumnLeft : $53abef11e3c2aac8$var$menuStyles.previewColumnRight,
        style: {
            transform: `translateY(${verticalDirection === 'up' ? -previewOffset.blockEnd : previewOffset.blockStart}px)`
        },
        testId: "remix-menu-preview-column"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $53abef11e3c2aac8$var$menuStyles.previewContent,
        testId: "remix-menu-preview"
    }, /*#__PURE__*/ $cozmU.createElement(IconComponent, {
        alt: label
    })));
}
function $53abef11e3c2aac8$var$RemixCategoryItem({ option: option, isActive: isActive, onActivate: onActivate, onFlatSelect: onFlatSelect, renderOptionIcon: renderOptionIcon }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const label = formatMessage(option.labelMessage);
    const optionIconAlt = formatMessage(option.iconAltMessage);
    const hasSubTypes = option.subTypes.length > 0;
    if (!hasSubTypes) return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        testId: `remix-menu-category-row-${option.type}`,
        onMouseEnter: (event)=>onActivate(option, event.currentTarget),
        onFocus: (event)=>onActivate(option, event.currentTarget)
    }, /*#__PURE__*/ $cozmU.createElement((0, $9d7Pd.default), {
        iconBefore: renderOptionIcon(option, optionIconAlt),
        testId: option.testId,
        onClick: ()=>onFlatSelect(option.type)
    }, label));
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        testId: `remix-menu-category-row-${option.type}`,
        onMouseEnter: (event)=>onActivate(option, event.currentTarget),
        onFocus: (event)=>onActivate(option, event.currentTarget)
    }, /*#__PURE__*/ $cozmU.createElement((0, $9d7Pd.default), {
        isSelected: isActive,
        iconBefore: renderOptionIcon(option, optionIconAlt),
        iconAfter: /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $53abef11e3c2aac8$var$menuStyles.categoryTrailing
        }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
            label: "",
            color: "var(--ds-icon, #292A2E)",
            size: "small"
        })),
        testId: option.testId,
        onClick: (event)=>onActivate(option, event.currentTarget)
    }, label));
}
function $53abef11e3c2aac8$export$5d44e1d911d4366f({ onOptionSelect: onOptionSelect, options: options, hiddenOptions: hiddenOptions, flyoutDirection: flyoutDirection = 'right', showFlyout: showFlyout = true, renderOptionIcon: renderOptionIcon, header: header, footer: footer }) {
    const verticalDirection = (0, $cozmU.useContext)($53abef11e3c2aac8$export$d7cf732af02b8895);
    const categoryColumnRef = (0, $cozmU.useRef)(null);
    const resolvedOptions = (0, $cozmU.useMemo)(()=>(0, $loej8.getRemixMenuOptions)({
            source: options === undefined ? {
                kind: 'preset',
                preset: 'selection'
            } : {
                kind: 'custom',
                choices: options
            },
            excludedRemixTypes: hiddenOptions ? [
                ...hiddenOptions
            ] : undefined
        }), [
        hiddenOptions,
        options
    ]); // The category whose sub-types are currently shown in the second column. Only
    // categories that have sub-types open a flyout; the rest close it.
    const [activeType, setActiveType] = (0, $cozmU.useState)(null); // Measured from both edges of the active category row, positioning the subtype card.
    const [categoryOffset, setCategoryOffset] = (0, $cozmU.useState)({
        blockStart: 0,
        blockEnd: 0
    }); // The sub-type currently hovered/focused, driving the preview column.
    const [hoveredSubType, setHoveredSubType] = (0, $cozmU.useState)(null); // Measured from both root edges so the preview center follows the subtype row center,
    // including when edge-row previews extend beyond the subtype card.
    const [previewOffset, setPreviewOffset] = (0, $cozmU.useState)({
        blockStart: 0,
        blockEnd: 0
    });
    const activeOption = (0, $cozmU.useMemo)(()=>resolvedOptions.find((opt)=>opt.type === activeType && opt.subTypes.length > 0) ?? null, [
        resolvedOptions,
        activeType
    ]);
    const activeSubTypes = activeOption?.subTypes ?? [];
    const hoveredSubTypeDef = activeSubTypes.find((st)=>st.value === hoveredSubType) ?? null;
    const handleActivate = (0, $cozmU.useCallback)((option, rowElement)=>{
        const categoryRect = categoryColumnRef.current?.getBoundingClientRect();
        const rowRect = rowElement.getBoundingClientRect();
        setCategoryOffset(categoryRect ? {
            blockStart: Math.max(0, rowRect.top - categoryRect.top),
            blockEnd: Math.max(0, categoryRect.bottom - rowRect.bottom)
        } : {
            blockStart: 0,
            blockEnd: 0
        });
        setActiveType(option.subTypes.length > 0 ? option.type : null);
        setHoveredSubType(null);
        setPreviewOffset({
            blockStart: 0,
            blockEnd: 0
        });
    }, []);
    const handleHoverSubType = (0, $cozmU.useCallback)((subTypeValue, nextPreviewOffset)=>{
        setHoveredSubType(subTypeValue);
        setPreviewOffset(nextPreviewOffset);
    }, []);
    const handleClearPreview = (0, $cozmU.useCallback)(()=>{
        setHoveredSubType(null);
        setPreviewOffset({
            blockStart: 0,
            blockEnd: 0
        });
    }, []);
    const handleFlatSelect = (0, $cozmU.useCallback)((type)=>{
        onOptionSelect?.({
            type: type
        });
    }, [
        onOptionSelect
    ]);
    const handleSubTypeSelect = (0, $cozmU.useCallback)((subTypeValue)=>{
        if (!activeOption) return;
        if ((0, $iDrrr.fg)('cc-maui-phase-3')) {
            const subTypeDef = activeOption.subTypes.find((st)=>st.value === subTypeValue);
            onOptionSelect?.({
                type: subTypeDef?.emitType ?? activeOption.type,
                subType: subTypeValue
            });
            return;
        }
        onOptionSelect?.({
            type: activeOption.type,
            subType: subTypeValue
        });
    }, [
        activeOption,
        onOptionSelect
    ]);
    const handlePickForMe = (0, $cozmU.useCallback)(()=>{
        if (!activeOption) return;
        const randomSubType = activeOption.subTypes[Math.floor(Math.random() * activeOption.subTypes.length)];
        if (!randomSubType) return;
        handleSubTypeSelect(randomSubType.value);
    }, [
        activeOption,
        handleSubTypeSelect
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: flyoutDirection === 'left' ? verticalDirection === 'up' ? $53abef11e3c2aac8$var$menuStyles.rootLeftUp : $53abef11e3c2aac8$var$menuStyles.rootLeftDown : verticalDirection === 'up' ? $53abef11e3c2aac8$var$menuStyles.rootRightUp : $53abef11e3c2aac8$var$menuStyles.rootRightDown,
        testId: "remix-menu"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        ref: categoryColumnRef,
        xcss: $53abef11e3c2aac8$var$menuStyles.categoryColumn,
        testId: "remix-menu-categories"
    }, header ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $53abef11e3c2aac8$var$menuStyles.categoryHeader,
        testId: "remix-menu-header"
    }, header) : null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, /*#__PURE__*/ $cozmU.createElement((0, $6IL1T.default), null, /*#__PURE__*/ $cozmU.createElement((0, $8FgJC.default), null, resolvedOptions.map((option)=>/*#__PURE__*/ $cozmU.createElement($53abef11e3c2aac8$var$RemixCategoryItem, {
            key: option.type,
            option: option,
            isActive: activeType === option.type,
            onActivate: handleActivate,
            onFlatSelect: handleFlatSelect,
            renderOptionIcon: renderOptionIcon
        }))))), footer), showFlyout && activeOption ? /*#__PURE__*/ $cozmU.createElement($53abef11e3c2aac8$var$RemixSubTypeColumn, {
        key: activeType,
        subTypes: activeSubTypes,
        categoryOffset: categoryOffset,
        pickForMeTestId: `${activeOption.testId}-pick-for-me`,
        onSubTypeSelect: handleSubTypeSelect,
        onPickForMe: handlePickForMe,
        onClearPreview: handleClearPreview,
        onHoverSubType: handleHoverSubType
    }) : null, showFlyout && hoveredSubTypeDef ? /*#__PURE__*/ $cozmU.createElement($53abef11e3c2aac8$var$RemixPreviewColumn, {
        subType: hoveredSubTypeDef,
        direction: flyoutDirection,
        previewOffset: previewOffset
    }) : null);
}
module.exports["CascadeVerticalDirectionContext"] = $53abef11e3c2aac8$export$d7cf732af02b8895;
module.exports["getCascadeVerticalDirectionForPlacement"] = $53abef11e3c2aac8$export$2ba0f43a8fa8308d;
module.exports["getCascadeDirectionForAnchor"] = $53abef11e3c2aac8$export$a1ba6991d30166a0;
module.exports["RemixCascadingMenuContent"] = $53abef11e3c2aac8$export$5d44e1d911d4366f;

});

parcelRegister("loej8", function(module, exports) {

var $gJ798 = parcelRequire("gJ798");


var $eFBG8 = parcelRequire("eFBG8");


var $2lF67 = parcelRequire("2lF67");


var $lBKFk = parcelRequire("lBKFk");


var $a79Sy = parcelRequire("a79Sy");


var $9KPiA = parcelRequire("9KPiA");


var $bDjVc = parcelRequire("bDjVc");


var $iDrrr = parcelRequire("iDrrr");


var $czfXc = parcelRequire("czfXc");

/**
 * All available remix options with their sub-types (variants).
 *
 * Sub-type values match the backend `dynamicUiSubtype` parameter
 * used in the remix-content minion (see edit-with-rovo-bar).
 */ const $1b429d4516497df0$var$defaultInfographicSubTypes = [
    {
        value: 'corporate-modern',
        displayName: 'modern style infographic',
        labelMessage: (0, $czfXc.default).subTypeModernStyle,
        testId: 'remix-sub-type-corporate-modern'
    },
    {
        value: 'corporate-doodle',
        displayName: 'sketch style infographic',
        labelMessage: (0, $czfXc.default).subTypeSketchStyle,
        testId: 'remix-sub-type-corporate-doodle'
    }
];
const $1b429d4516497df0$var$newInfographicSubTypes = [
    {
        value: 'charlie',
        displayName: 'bold style infographic',
        labelMessage: (0, $czfXc.default).subTypeBoldStyle,
        testId: 'remix-sub-type-charlie'
    },
    {
        value: 'minimalist',
        displayName: 'minimalist style infographic',
        labelMessage: (0, $czfXc.default).subTypeMinimalistStyle,
        testId: 'remix-sub-type-minimalist'
    },
    {
        value: 'corporate-doodle',
        displayName: 'sketch style infographic',
        labelMessage: (0, $czfXc.default).subTypeSketchStyle,
        testId: 'remix-sub-type-corporate-doodle'
    }
];
function $1b429d4516497df0$export$b867d47ced1865f7() {
    return (0, $iDrrr.fg)('cc-maui-phase-2') ? $1b429d4516497df0$var$newInfographicSubTypes : $1b429d4516497df0$var$defaultInfographicSubTypes;
}
const $1b429d4516497df0$var$defaultVisualAidSubTypes = [
    {
        value: 'flip-card',
        displayName: 'flip card',
        labelMessage: (0, $czfXc.default).subTypeFlipCard,
        testId: 'remix-sub-type-flip-card'
    },
    {
        value: 'quadrant',
        displayName: 'quadrant',
        labelMessage: (0, $czfXc.default).subTypeQuadrant,
        testId: 'remix-sub-type-quadrant'
    },
    {
        value: 'tree-map',
        displayName: 'tree map',
        labelMessage: (0, $czfXc.default).subTypeTreeMap,
        testId: 'remix-sub-type-tree-map'
    },
    {
        value: 'horizontal-timeline',
        displayName: 'timeline',
        labelMessage: (0, $czfXc.default).subTypeTimeline,
        testId: 'remix-sub-type-horizontal-timeline'
    },
    {
        value: 'map',
        displayName: 'map',
        labelMessage: (0, $czfXc.default).subTypeGeographicalMap,
        testId: 'remix-sub-type-map'
    },
    {
        value: 'org-chart',
        displayName: 'org chart',
        labelMessage: (0, $czfXc.default).subTypeOrgChart,
        testId: 'remix-sub-type-org-chart'
    }
];
const $1b429d4516497df0$var$imageSubType = {
    value: 'image',
    displayName: 'image',
    labelMessage: (0, $czfXc.default).subTypeImage,
    testId: 'remix-sub-type-image',
    emitType: 'image'
};
function $1b429d4516497df0$export$b9ec4f683b57ea1d() {
    return (0, $iDrrr.fg)('cc-maui-phase-3') ? [
        ...$1b429d4516497df0$var$defaultVisualAidSubTypes,
        $1b429d4516497df0$var$imageSubType
    ] : $1b429d4516497df0$var$defaultVisualAidSubTypes;
}
const $1b429d4516497df0$export$f0ba07b8deaf6c2d = [
    {
        type: 'chart',
        displayName: 'chart',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gJ798))),
        labelMessage: (0, $czfXc.default).remixOptionChart,
        iconAltMessage: (0, $czfXc.default).chartIconAlt,
        tooltipMessage: (0, $czfXc.default).chartTooltip,
        testId: 'remix-overlay-option-chart',
        subTypes: [
            {
                value: 'line-chart',
                displayName: 'line chart',
                labelMessage: (0, $czfXc.default).subTypeLineChart,
                testId: 'remix-sub-type-line-chart'
            },
            {
                value: 'area-chart',
                displayName: 'area chart',
                labelMessage: (0, $czfXc.default).subTypeAreaChart,
                testId: 'remix-sub-type-area-chart'
            },
            {
                value: 'bar-chart',
                displayName: 'bar chart',
                labelMessage: (0, $czfXc.default).subTypeBarChart,
                testId: 'remix-sub-type-bar-chart'
            },
            {
                value: 'funnel-chart',
                displayName: 'funnel chart',
                labelMessage: (0, $czfXc.default).subTypeFunnelChart,
                testId: 'remix-sub-type-funnel-chart'
            },
            {
                value: 'pie-chart',
                displayName: 'pie chart',
                labelMessage: (0, $czfXc.default).subTypePieChart,
                testId: 'remix-sub-type-pie-chart'
            },
            {
                value: 'gantt-chart',
                displayName: 'Gantt chart',
                labelMessage: (0, $czfXc.default).subTypeGanttChart,
                testId: 'remix-sub-type-gantt-chart'
            }
        ]
    },
    {
        type: 'diagram',
        displayName: 'diagram',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($eFBG8))),
        labelMessage: (0, $czfXc.default).remixOptionDiagram,
        iconAltMessage: (0, $czfXc.default).diagramIconAlt,
        tooltipMessage: (0, $czfXc.default).diagramTooltip,
        testId: 'remix-overlay-option-diagram',
        subTypes: [
            {
                value: 'mindmap',
                displayName: 'mind map',
                labelMessage: (0, $czfXc.default).subTypeMindMap,
                testId: 'remix-sub-type-mindmap'
            },
            {
                value: 'flowchart',
                displayName: 'flowchart',
                labelMessage: (0, $czfXc.default).subTypeFlowChart,
                testId: 'remix-sub-type-flowchart'
            }
        ]
    },
    {
        type: 'infographic',
        displayName: 'infographic',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2lF67))),
        labelMessage: (0, $czfXc.default).remixOptionInfographic,
        iconAltMessage: (0, $czfXc.default).infographicIconAlt,
        tooltipMessage: (0, $czfXc.default).infographicTooltip,
        testId: 'remix-overlay-option-infographic',
        subTypes: $1b429d4516497df0$var$defaultInfographicSubTypes
    },
    {
        type: 'visual-aid',
        displayName: 'visualization',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($a79Sy))),
        labelMessage: (0, $czfXc.default).remixOptionVisualization,
        iconAltMessage: (0, $czfXc.default).visualizationIconAlt,
        tooltipMessage: (0, $czfXc.default).visualizationTooltip,
        testId: 'remix-overlay-option-visual-aid',
        subTypes: $1b429d4516497df0$var$defaultVisualAidSubTypes
    }
];
const $1b429d4516497df0$export$839e8948e17d6e68 = [
    {
        type: 'slides',
        displayName: 'slides',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9KPiA))),
        labelMessage: (0, $czfXc.default).remixOptionSlides,
        iconAltMessage: (0, $czfXc.default).slidesIconAlt,
        tooltipMessage: (0, $czfXc.default).slidesTooltip,
        testId: 'remix-overlay-option-slides',
        subTypes: [],
        iconTileAppearance: 'green'
    },
    {
        type: 'whiteboard',
        displayName: 'whiteboard',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))),
        labelMessage: (0, $czfXc.default).remixOptionWhiteboard,
        iconAltMessage: (0, $czfXc.default).whiteboardIconAlt,
        tooltipMessage: (0, $czfXc.default).whiteboardTooltip,
        testId: 'remix-overlay-option-whiteboard',
        subTypes: [],
        iconTileAppearance: 'teal'
    },
    {
        type: 'database',
        displayName: 'database',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lBKFk))),
        labelMessage: (0, $czfXc.default).remixOptionDatabase,
        iconAltMessage: (0, $czfXc.default).databaseIconAlt,
        tooltipMessage: (0, $czfXc.default).databaseTooltip,
        testId: 'remix-overlay-option-database',
        subTypes: [],
        iconTileAppearance: 'purple'
    },
    {
        type: 'infographic',
        displayName: 'infographic',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2lF67))),
        labelMessage: (0, $czfXc.default).remixOptionInfographic,
        iconAltMessage: (0, $czfXc.default).infographicIconAlt,
        tooltipMessage: (0, $czfXc.default).infographicTooltip,
        testId: 'remix-overlay-option-infographic',
        subTypes: $1b429d4516497df0$var$defaultInfographicSubTypes
    }
];
function $1b429d4516497df0$var$applyGatedSubTypes(remixChoices) {
    const infographicSubTypes = $1b429d4516497df0$export$b867d47ced1865f7();
    const visualAidSubTypes = $1b429d4516497df0$export$b9ec4f683b57ea1d();
    return remixChoices.map((opt)=>{
        if (opt.type === 'infographic') return {
            ...opt,
            subTypes: infographicSubTypes
        };
        if (opt.type === 'visual-aid') return {
            ...opt,
            subTypes: visualAidSubTypes
        };
        return opt;
    });
}
function $1b429d4516497df0$export$eba289419a85029b({ source: source = {
    kind: 'preset',
    preset: 'selection'
}, excludedRemixTypes: excludedRemixTypes } = {}) {
    let sourceChoices;
    switch(source.kind){
        case 'preset':
            sourceChoices = source.preset === 'page' ? $1b429d4516497df0$export$839e8948e17d6e68 : $1b429d4516497df0$export$f0ba07b8deaf6c2d;
            break;
        case 'custom':
            sourceChoices = source.choices;
            break;
    }
    return $1b429d4516497df0$export$cf3073d90a2d0bae($1b429d4516497df0$var$applyGatedSubTypes(sourceChoices), excludedRemixTypes);
}
/** Render-time lookup reflects current feature gates */ function $1b429d4516497df0$var$getAllOptions() {
    return $1b429d4516497df0$export$eba289419a85029b({
        source: {
            kind: 'custom',
            choices: [
                ...$1b429d4516497df0$export$f0ba07b8deaf6c2d,
                ...$1b429d4516497df0$export$839e8948e17d6e68
            ]
        }
    });
}
function $1b429d4516497df0$export$cf3073d90a2d0bae(remixChoices, excludedRemixTypes) {
    if (!excludedRemixTypes?.length) return remixChoices;
    const excludedRemixTypeSet = new Set(excludedRemixTypes);
    return remixChoices.filter((choice)=>choice.type === 'custom' || !excludedRemixTypeSet.has(choice.type));
}
function $1b429d4516497df0$export$b3104233810c1e93(typeValue) {
    const match = $1b429d4516497df0$var$getAllOptions().find((option)=>option.type === typeValue);
    return match?.displayName ?? typeValue.replace(/-/g, ' ');
}
function $1b429d4516497df0$export$ca76798d0446453(subTypeValue) {
    for (const option of $1b429d4516497df0$var$getAllOptions()){
        const match = option.subTypes.find((st)=>st.value === subTypeValue);
        if (match) return match.displayName;
    }
    return subTypeValue.replace(/-/g, ' ');
}
const $1b429d4516497df0$var$DEFAULT_REMIX_PROMPTS = {
    chart: 'Remix the selected content as a chart',
    custom: 'Remix the selected content',
    database: 'Remix the selected content as a database',
    diagram: 'Remix the selected content as a diagram',
    image: 'Remix the selected content as an image',
    infographic: 'Remix the selected content as an infographic',
    slides: 'Remix the selected content as slides',
    'visual-aid': 'Remix the selected content as a visualization',
    whiteboard: 'Remix the selected content as a whiteboard'
};
function $1b429d4516497df0$export$376994f626d15236(typeValue, subTypeValue) {
    if (!subTypeValue) return $1b429d4516497df0$var$DEFAULT_REMIX_PROMPTS[typeValue];
    const subTypeDisplayName = $1b429d4516497df0$export$ca76798d0446453(subTypeValue);
    const article = /^[aeiou]/i.test(subTypeDisplayName) ? 'an' : 'a';
    return `Remix the selected content as ${article} ${subTypeDisplayName}`;
}
function $1b429d4516497df0$export$bd80fc308a7bbe16(dynamicUiType, dynamicUiSubtype) {
    const allOptions = $1b429d4516497df0$var$getAllOptions();
    // First, try to find the category by matching the dynamicUiType directly.
    let matchedOption = allOptions.find((opt)=>opt.type === dynamicUiType);
    // If the direct match doesn't contain the requested sub-type (e.g. the
    // node's emitType points to a different category than where the sub-type
    // actually lives), or if no category matched at all, fall back to scanning
    // all categories for a sub-type whose value or emitType matches.
    if (dynamicUiSubtype) {
        const subtypeInMatch = matchedOption?.subTypes.some((st)=>st.value === dynamicUiSubtype);
        if (!matchedOption || !subtypeInMatch) {
            const fallback = allOptions.find((opt)=>opt.subTypes.some((st)=>st.value === dynamicUiSubtype || st.emitType === dynamicUiType));
            if (fallback) matchedOption = fallback;
        }
    } else if (!matchedOption) {
        // No subtype provided and no direct category match — the dynamicUiType
        // may be an emitType override (e.g. 'image' which is a sub-type in
        // 'visual-aid' with emitType: 'image'). Scan all categories for a
        // sub-type whose emitType matches.
        const fallback = allOptions.find((opt)=>opt.subTypes.some((st)=>st.emitType === dynamicUiType));
        if (fallback) matchedOption = fallback;
    }
    // No matching category, or category has no sub-types (e.g. slides, whiteboard)
    if (!matchedOption || matchedOption.subTypes.length === 0) return null;
    const groupLabel = matchedOption.labelMessage.defaultMessage ?? '';
    const groupLabelMessage = matchedOption.labelMessage;
    // Find the current sub-type within the matched category.
    // When dynamicUiSubtype is provided, match by value directly.
    // When only dynamicUiType is provided (no subtype), try to find a sub-type
    // whose emitType matches dynamicUiType (e.g. emitType: 'image' → the 'image' sub-type).
    let currentSubType = dynamicUiSubtype ? matchedOption.subTypes.find((st)=>st.value === dynamicUiSubtype) : matchedOption.subTypes.find((st)=>st.emitType === dynamicUiType);
    // If a subtype was provided but not found in this category, return null
    // to avoid showing a broken dropdown.
    if (dynamicUiSubtype && !currentSubType) return null;
    // Variants with `emitType` are only selectable from the remix-overlay.
    // When the active subtype has an emitType override, hide the switcher
    // entirely so the user cannot switch away from it.
    if (currentSubType?.emitType) return null;
    // Filter out emitType variants from the switcher — they should only
    // appear in the remix-overlay, not in the editor toolbar dropdown.
    const filteredSubTypes = matchedOption.subTypes.filter((st)=>!st.emitType);
    if (filteredSubTypes.length === 0) return null;
    // Fall back to category-level label if no sub-type is set
    // (e.g. "Pick for me" was used).
    const currentLabel = currentSubType ? currentSubType.labelMessage.defaultMessage ?? '' : groupLabel;
    const currentLabelMessage = currentSubType ? currentSubType.labelMessage : groupLabelMessage;
    return {
        groupLabel: groupLabel,
        groupLabelMessage: groupLabelMessage,
        currentLabel: currentLabel,
        currentLabelMessage: currentLabelMessage,
        siblingSubTypes: filteredSubTypes
    };
}
module.exports["PAGE_REMIX_OPTIONS"] = $1b429d4516497df0$export$839e8948e17d6e68;
module.exports["getRemixMenuOptions"] = $1b429d4516497df0$export$eba289419a85029b;
module.exports["getTypeDisplayName"] = $1b429d4516497df0$export$b3104233810c1e93;
module.exports["getSubTypeDisplayName"] = $1b429d4516497df0$export$ca76798d0446453;
module.exports["getDefaultRemixPromptText"] = $1b429d4516497df0$export$376994f626d15236;
module.exports["getRemixSwitcherInfo"] = $1b429d4516497df0$export$bd80fc308a7bbe16;

});

parcelRegister("lTU4O", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $cXtTj = parcelRequire("cXtTj");


var $2TZSo = parcelRequire("2TZSo");


var $isp1U = parcelRequire("isp1U");

const $1dccc6823e49008a$export$205c270e325a7524 = (aaid)=>{
    const preferences = JSON.parse(// eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem((0, $2TZSo.LS_USER_PREFERENCES_KEY)) || '{}');
    return preferences[aaid];
};
const $1dccc6823e49008a$var$store = (0, $8s9DV.createStore)({
    initialState: {
        preferences: {
            // ideally we want to set the preference in the react component because
            // FF evaluated in module level may not resolve to correct value during SSR
            // however because there is localStorage setting and `firstLoad`, it requires a bit of refactoring to do it
            // this feature is only needed for dogfooding, so may not worth the refactor
            storeUserMessages: // eslint-disable-next-line @atlaskit/platform/no-module-level-eval
            (0, $cXtTj.default).initializeCalled() && (0, $cXtTj.default).checkGate('ai_mate_show_store_messages'),
            // default is undefined because we do not want migration to be started until we read from local storage value
            storeUserMessageMigratedToBE: undefined,
            useEditorContext: true
        },
        firstLoad: true
    },
    actions: {
        updatePreferences: (data)=>({ setState: setState, getState: getState })=>{
                setState({
                    preferences: {
                        ...getState().preferences,
                        ...data
                    },
                    firstLoad: false
                });
            }
    }
});
const $1dccc6823e49008a$var$useStore = (0, $kBr4q.createHook)($1dccc6823e49008a$var$store);
const $1dccc6823e49008a$export$b6472e0d8983f5f5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(27);
    const { aaid: aaid } = (0, $isp1U.useProfileController)();
    const [t0, t1] = $1dccc6823e49008a$var$useStore();
    const { preferences: preferences, firstLoad: firstLoad } = t0;
    const { updatePreferences: storeUpdatePreferences } = t1;
    let t2;
    if ($[0] !== aaid || $[1] !== preferences || $[2] !== storeUpdatePreferences) {
        t2 = (data)=>{
            if (!aaid) return;
            storeUpdatePreferences(data);
            localStorage.setItem((0, $2TZSo.LS_USER_PREFERENCES_KEY), JSON.stringify({
                [aaid]: {
                    ...preferences,
                    ...data
                }
            }));
        };
        $[0] = aaid;
        $[1] = preferences;
        $[2] = storeUpdatePreferences;
        $[3] = t2;
    } else t2 = $[3];
    const updatePreferences = t2;
    let t3;
    if ($[4] !== updatePreferences) {
        t3 = (storeUserMessages)=>{
            updatePreferences({
                storeUserMessages: storeUserMessages
            });
        };
        $[4] = updatePreferences;
        $[5] = t3;
    } else t3 = $[5];
    const setStoreUserMessages = t3;
    let t4;
    if ($[6] !== updatePreferences) {
        t4 = (useEditorContext)=>{
            updatePreferences({
                useEditorContext: useEditorContext
            });
        };
        $[6] = updatePreferences;
        $[7] = t4;
    } else t4 = $[7];
    const setUseEditorContext = t4;
    let t5;
    if ($[8] !== aaid || $[9] !== updatePreferences) {
        t5 = ()=>{
            if (!aaid) return;
            updatePreferences({
                storeUserMessageMigratedToBE: true
            });
        };
        $[8] = aaid;
        $[9] = updatePreferences;
        $[10] = t5;
    } else t5 = $[10];
    const markStoreUserMessageMigratedToBE = t5;
    let t6;
    if ($[11] !== updatePreferences) {
        t6 = (hasSeenFeedbackOptInPrompt)=>{
            updatePreferences({
                hasSeenFeedbackOptInPrompt: hasSeenFeedbackOptInPrompt
            });
        };
        $[11] = updatePreferences;
        $[12] = t6;
    } else t6 = $[12];
    const setHasSeenFeedbackOptInPrompt = t6;
    let t7;
    let t8;
    if ($[13] !== aaid || $[14] !== firstLoad || $[15] !== updatePreferences) {
        t7 = ()=>{
            if (aaid && firstLoad) {
                const preferences_0 = $1dccc6823e49008a$export$205c270e325a7524(aaid);
                if (preferences_0) updatePreferences({
                    ...preferences_0,
                    ...preferences_0.storeUserMessageMigratedToBE ? {} : {
                        storeUserMessageMigratedToBE: false
                    }
                });
            }
        };
        t8 = [
            aaid,
            firstLoad,
            updatePreferences
        ];
        $[13] = aaid;
        $[14] = firstLoad;
        $[15] = updatePreferences;
        $[16] = t7;
        $[17] = t8;
    } else {
        t7 = $[16];
        t8 = $[17];
    }
    (0, $cozmU.useEffect)(t7, t8);
    const t9 = aaid ? preferences.storeUserMessageMigratedToBE : undefined;
    let t10;
    if ($[18] !== preferences || $[19] !== t9) {
        t10 = {
            ...preferences,
            storeUserMessageMigratedToBE: t9
        };
        $[18] = preferences;
        $[19] = t9;
        $[20] = t10;
    } else t10 = $[20];
    let t11;
    if ($[21] !== markStoreUserMessageMigratedToBE || $[22] !== setHasSeenFeedbackOptInPrompt || $[23] !== setStoreUserMessages || $[24] !== setUseEditorContext || $[25] !== t10) {
        t11 = {
            preferences: t10,
            setStoreUserMessages: setStoreUserMessages,
            setUseEditorContext: setUseEditorContext,
            setHasSeenFeedbackOptInPrompt: setHasSeenFeedbackOptInPrompt,
            markStoreUserMessageMigratedToBE: markStoreUserMessageMigratedToBE
        };
        $[21] = markStoreUserMessageMigratedToBE;
        $[22] = setHasSeenFeedbackOptInPrompt;
        $[23] = setStoreUserMessages;
        $[24] = setUseEditorContext;
        $[25] = t10;
        $[26] = t11;
    } else t11 = $[26];
    return t11;
} : ()=>{
    const { aaid: aaid } = (0, $isp1U.useProfileController)();
    const [{ preferences: preferences, firstLoad: firstLoad }, { updatePreferences: storeUpdatePreferences }] = $1dccc6823e49008a$var$useStore();
    const updatePreferences = (0, $cozmU.useCallback)((data)=>{
        if (!aaid) return;
        storeUpdatePreferences(data);
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        localStorage.setItem((0, $2TZSo.LS_USER_PREFERENCES_KEY), JSON.stringify({
            [aaid]: {
                ...preferences,
                ...data
            }
        }));
    }, [
        aaid,
        preferences,
        storeUpdatePreferences
    ]);
    const setStoreUserMessages = (0, $cozmU.useCallback)((storeUserMessages)=>{
        updatePreferences({
            storeUserMessages: storeUserMessages
        });
    }, [
        updatePreferences
    ]);
    const setUseEditorContext = (0, $cozmU.useCallback)((useEditorContext)=>{
        updatePreferences({
            useEditorContext: useEditorContext
        });
    }, [
        updatePreferences
    ]);
    const markStoreUserMessageMigratedToBE = (0, $cozmU.useCallback)(()=>{
        if (!aaid) return;
        updatePreferences({
            storeUserMessageMigratedToBE: true
        });
    }, [
        updatePreferences,
        aaid
    ]);
    const setHasSeenFeedbackOptInPrompt = (0, $cozmU.useCallback)((hasSeenFeedbackOptInPrompt)=>{
        updatePreferences({
            hasSeenFeedbackOptInPrompt: hasSeenFeedbackOptInPrompt
        });
    }, [
        updatePreferences
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (aaid && firstLoad) {
            const preferences_0 = $1dccc6823e49008a$export$205c270e325a7524(aaid);
            if (preferences_0) updatePreferences({
                ...preferences_0,
                ...preferences_0.storeUserMessageMigratedToBE ? {} : {
                    storeUserMessageMigratedToBE: false
                }
            });
        }
    }, [
        aaid,
        firstLoad,
        updatePreferences
    ]);
    return {
        preferences: {
            ...preferences,
            storeUserMessageMigratedToBE: aaid ? preferences.storeUserMessageMigratedToBE : undefined
        },
        setStoreUserMessages: setStoreUserMessages,
        setUseEditorContext: setUseEditorContext,
        setHasSeenFeedbackOptInPrompt: setHasSeenFeedbackOptInPrompt,
        markStoreUserMessageMigratedToBE: markStoreUserMessageMigratedToBE
    };
};
module.exports["useUserPreferences"] = $1dccc6823e49008a$export$b6472e0d8983f5f5;

});

parcelRegister("2TZSo", function(module, exports) {
const $9ca4df0845d80c9e$export$97d0beb2ccc70a4d = 'aiMateUserPreferences';
module.exports["LS_USER_PREFERENCES_KEY"] = $9ca4df0845d80c9e$export$97d0beb2ccc70a4d;

});

parcelRegister("3OD5k", function(module, exports) {
const $84c94bf7c9d9425b$export$5f321bb161ebfd54 = (contentType)=>contentType === 'blogpost' ? 'blogpost' : 'page';
module.exports["resolveRemixDynamicUiContentType"] = $84c94bf7c9d9425b$export$5f321bb161ebfd54;

});

parcelRegister("3rRes", function(module, exports) {

var $jTt8P = parcelRequire("jTt8P");


var $1qYXT = parcelRequire("1qYXT");

const $b43257b5198523a8$export$cee0b7c2921c06e1 = (nodes)=>{
    if (nodes === null) return null;
    const result = [];
    for (const node of nodes){
        const filtered = (0, $jTt8P.traverse)(node, {
            any: (adfNode)=>{
                if ((0, $1qYXT.isRemixRestrictedNodeType)(adfNode.type)) return false;
            }
        });
        if (filtered !== false) result.push(filtered);
    }
    return result;
};
module.exports["filterRemixFragmentNodes"] = $b43257b5198523a8$export$cee0b7c2921c06e1;

});

parcelRegister("caVF7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $1118b6b7a2cd5d89$export$c8a930cce8a67fba = ({ onOpenPreview: onOpenPreview })=>{
    const [isComplete, setIsComplete] = (0, $cozmU.useState)(false);
    const signalActionReady = (0, $cozmU.useCallback)(()=>{
        // Defer opening the preview until the progress bar fills to 100%.
        setIsComplete(true);
    }, []);
    const resetCompletion = (0, $cozmU.useCallback)(()=>{
        setIsComplete(false);
    }, []);
    return (0, $cozmU.useMemo)(()=>({
            showProgressBar: true,
            isComplete: isComplete,
            onCompleteAnimationFinished: onOpenPreview,
            signalActionReady: signalActionReady,
            resetCompletion: resetCompletion
        }), [
        isComplete,
        onOpenPreview,
        signalActionReady,
        resetCompletion
    ]);
};
module.exports["useRemixThinkingBarProgress"] = $1118b6b7a2cd5d89$export$c8a930cce8a67fba;

});

parcelRegister("hxqA6", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $ep3mz = parcelRequire("ep3mz");


var $kqIWy = parcelRequire("kqIWy");

const $37285b1cb0d2d316$var$NO_HIDDEN_OPTIONS = [];
const $37285b1cb0d2d316$export$ddcfdb99d720c6b3 = ()=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { data: spaceDetail } = (0, $kqIWy.useSpaceDetail)(spaceKey, {
        includeSpaceTypeSettings: true
    });
    const isWhiteboardsEnabled = spaceDetail?.typeSettings?.enabledContentTypes?.isWhiteboardsEnabled ?? false;
    const enabledContentTypes = spaceDetail?.typeSettings?.enabledContentTypes;
    const hiddenOptions = [];
    // Only hide the diagram option when whiteboards are unavailable for the space
    if (!isWhiteboardsEnabled && (0, $6mKj3.expVal)('cc_maui_polish_changes_batch_2', 'isEnabled', false)) hiddenOptions.push('diagram');
    if (!enabledContentTypes?.isWhiteboardsEnabled) hiddenOptions.push('whiteboard');
    if (!enabledContentTypes?.isDatabasesEnabled) hiddenOptions.push('database');
    if (!enabledContentTypes?.isSlidesEnabled) hiddenOptions.push('slides');
    return hiddenOptions.length > 0 ? hiddenOptions : $37285b1cb0d2d316$var$NO_HIDDEN_OPTIONS;
};
module.exports["useShouldHideDiagramRemixOption"] = $37285b1cb0d2d316$export$ddcfdb99d720c6b3;

});

parcelRegister("7eOZ4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kyKWe = parcelRequire("kyKWe");


var $iDrrr = parcelRequire("iDrrr");


var $kuGC4 = parcelRequire("kuGC4");


var $kNXXO = parcelRequire("kNXXO");


var $c5wKe = parcelRequire("c5wKe");


var $i7OAD = parcelRequire("i7OAD");


var $aYC8J = parcelRequire("aYC8J");


var $igOtY = parcelRequire("igOtY");


var $iW40i = parcelRequire("iW40i");


var $8akfd = parcelRequire("8akfd");


var $lTU4O = parcelRequire("lTU4O");


var $loej8 = parcelRequire("loej8");


var $ew8wg = parcelRequire("ew8wg");


var $6mKj3 = parcelRequire("6mKj3");


var $3jwuS = parcelRequire("3jwuS");


var $ep3mz = parcelRequire("ep3mz");


var $htsj6 = parcelRequire("htsj6");


var $ficwO = parcelRequire("ficwO");


var $jyA9t = parcelRequire("jyA9t");

const $1e31de274ed01603$var$isActionComplete = (chatMessages)=>{
    // Scan backwards to find ACTION_COMPLETE in the latest turn.
    // If we encounter a HUMAN message first, that marks a turn boundary —
    // any ACTION_COMPLETE before it belongs to a previous turn.
    let hasActionCompleteStep = false;
    for(let i = chatMessages.length - 1; i >= 0; i--){
        const message = chatMessages[i];
        if (message.type === 'ACTION_COMPLETE') {
            hasActionCompleteStep = true;
            break;
        }
        if ((0, $igOtY.isStoreHuman)(message)) break;
    }
    const lastPlannedAIFCAction = (0, $kNXXO.findLastAssistantAction)(chatMessages, (action)=>(0, $i7OAD.isAIFCAction)(action) && action.status === 'planned');
    const hasCompletedAction = lastPlannedAIFCAction !== undefined;
    if ((0, $iDrrr.fg)('remix_product_modal_rovo_chat')) return hasActionCompleteStep || hasCompletedAction;
    else return hasActionCompleteStep;
};
/**
 * True when the latest turn contains ACTION_PREPARE but no ACTION_COMPLETE.
 * This happens when AdfEditorMinion early-exits with "no operations returned
 * by LLM" — the stream completes but the action is never sealed.
 */ const $1e31de274ed01603$var$hasActionPrepareWithoutComplete = (chatMessages)=>{
    let hasActionPrepare = false;
    for(let i = chatMessages.length - 1; i >= 0; i--){
        const message = chatMessages[i];
        if (message.type === 'ACTION_COMPLETE') return false;
        if (message.type === 'ACTION_PREPARE') hasActionPrepare = !!message.action && (0, $aYC8J.isRemixGeneratedFlow)(message.action);
        if ((0, $igOtY.isStoreHuman)(message)) break;
    }
    return hasActionPrepare;
};
function $1e31de274ed01603$var$shouldOpenEphemeralPreview(chatMessages) {
    for(let i = chatMessages.length - 1; i >= 0; i--){
        const message = chatMessages[i];
        if (message.type === 'ACTION_PREPARE') {
            if (!message.action) return false;
            if (!(0, $aYC8J.isRemixGeneratedFlow)(message.action)) return false;
            if ($1e31de274ed01603$var$isWhiteboardRemixActionKey(message.action.key) && !(0, $aYC8J.getDynamicUiSubtype)(message.action)) return false;
            return true;
        }
    }
    return false;
}
const $1e31de274ed01603$var$isWhiteboardRemixActionKey = (key)=>key === (0, $aYC8J.CONFLUENCE_AIFC_WHITEBOARD_CREATE_KEY) || key === (0, $aYC8J.CONFLUENCE_AIFC_WHITEBOARD_UPDATE_KEY);
/**
 * True when the latest matching assistant action is a whiteboard create/update
 * and checks if the action is in the ACTION_PART streaming status.
 * (`MessageAction.status === 'streaming'`).
 */ const $1e31de274ed01603$var$hasWhiteboardRemixActionStreaming = (chatMessages)=>(0, $kNXXO.findLastAssistantAction)(chatMessages, (action)=>$1e31de274ed01603$var$isWhiteboardRemixActionKey(action.key) && action.status?.toLowerCase() === 'streaming') !== undefined;
const $1e31de274ed01603$export$cca9e2432f59b3f8 = ({ onActionReady: onActionReady, stagingAreaTargetMode: stagingAreaTargetMode = 'current-content', onPreviewOpened: onPreviewOpened, onSubmitted: onSubmitted, onPreviewDismissed: onPreviewDismissed, trackRemixConversationById: trackRemixConversationById = false } = {})=>{
    const { sendMessage: sendMessage, createConversationOptimistically: createConversationOptimistically, abortRequests: abortRequests, activeConversation: activeConversation, setSelectedConversation: setSelectedConversation } = (0, $c5wKe.useSmartCreationChatStoreApi)();
    const { setPrompt: setPrompt, setDynamicUiContext: setDynamicUiContext, setUserSelectedDynamicUiSubtype: setUserSelectedDynamicUiSubtype, setInteractionSource: setInteractionSource, setForceSkipAutoConversationSelection: setForceSkipAutoConversationSelection } = (0, $8akfd.useStagingAreaActions)();
    const { preferences: preferences } = (0, $lTU4O.useUserPreferences)();
    const { openModal: openModal, closeModal: closeModal } = (0, $jyA9t.useSmartCreationModalActions)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { title: contentTitle } = (0, $ew8wg.usePageTitle)({
        contentId: contentId ?? ''
    });
    const { contentStatus: contentStatus } = (0, $htsj6.useContentStatus)();
    const isDraftPage = contentStatus === 'draft';
    // Track the conversation ID created by this remix flow. Only when the
    // store's activeConversation matches this ID do we consider it "ours".
    // Stored as state so that setting it triggers a rerender, ensuring
    // derived values (activeRemixConversation, chatMessages, etc.) update
    // immediately rather than waiting for an external rerender.
    const [remixConversationId, setRemixConversationId] = (0, $cozmU.useState)(undefined);
    const resetRemixConversationId = (0, $cozmU.useCallback)(()=>{
        setRemixConversationId(undefined);
    }, []);
    const remixConversation = (0, $kuGC4.useConversationById)({
        conversationId: remixConversationId ?? ''
    });
    const shouldTrackRemixConversationById = trackRemixConversationById && (0, $6mKj3.expVal)('cc_maui_polish_changes_batch_5', 'isEnabled', false);
    const activeRemixConversation = shouldTrackRemixConversationById ? remixConversation ?? null : activeConversation?.id && activeConversation.id === remixConversationId ? activeConversation : null;
    const [chatMessages] = (0, $iW40i.useChatMessages)({
        conversationId: shouldTrackRemixConversationById ? remixConversationId ?? '' : activeRemixConversation?.id ?? ''
    });
    const isRemixCancelled = shouldTrackRemixConversationById && remixConversation?.lastAgentMessageStatus === 'CANCELLED';
    // Extract the first StoreError from chatMessages so callers can surface
    // the specific Rovo error message as an experience attribute.
    const remixStoreError = chatMessages.find((message)=>(0, $igOtY.isStoreError)(message)) ?? null;
    // Detect whether Rovo encountered an error while processing a remix request.
    // This covers ACTION_ERROR at any stage — both before the ephemeral preview
    // opens (during awaitingResponse) and while it is loading (during typingResponse).
    // Uses the same isStoreError check as the smart-creation staging area.
    const isRemixError = activeRemixConversation?.status === (0, $igOtY.CHAT_STORE_STATUS).deactivatedAgentError || remixStoreError !== null;
    const isRemixAborted = !isRemixError && activeRemixConversation?.status === (0, $igOtY.CHAT_STORE_STATUS).idle && !$1e31de274ed01603$var$isActionComplete(chatMessages) && !$1e31de274ed01603$var$hasActionPrepareWithoutComplete(chatMessages) && chatMessages.some((0, $igOtY.isStoreAssistant));
    // Track whether the onActionReady callback has already been fired for the
    // current conversation to avoid duplicate invocations.
    const actionReadyFired = (0, $cozmU.useRef)(false);
    // Reset the fired flag when the active remix conversation changes (new remix flow).
    const prevConversationId = (0, $cozmU.useRef)(activeRemixConversation?.id);
    (0, $cozmU.useEffect)(()=>{
        if (prevConversationId.current !== activeRemixConversation?.id) {
            actionReadyFired.current = false;
            prevConversationId.current = activeRemixConversation?.id;
        }
    }, [
        activeRemixConversation?.id
    ]);
    // Fire onActionReady when the appropriate message arrives:
    // - For whiteboard create/update: when the action is `streaming` (early trigger so
    //   the whiteboard preview can start rendering while data is still arriving).
    // - For all other actions: when FINAL_RESPONSE is received from the stream,
    //   indicated by the conversation status transitioning to `idle`.
    // - Fallback: when the stream completed (idle) with ACTION_PREPARE but no
    //   ACTION_COMPLETE (AdfEditorMinion early-exit).
    (0, $cozmU.useEffect)(()=>{
        if (actionReadyFired.current || !onActionReady || isRemixCancelled) return;
        const whiteboardStreamingDetected = $1e31de274ed01603$var$hasWhiteboardRemixActionStreaming(chatMessages);
        const finalResponseReceived = activeRemixConversation?.status === (0, $igOtY.CHAT_STORE_STATUS).idle && $1e31de274ed01603$var$isActionComplete(chatMessages);
        const actionPreparedButNotCompleted = activeRemixConversation?.status === (0, $igOtY.CHAT_STORE_STATUS).idle && $1e31de274ed01603$var$hasActionPrepareWithoutComplete(chatMessages);
        if (whiteboardStreamingDetected || finalResponseReceived || actionPreparedButNotCompleted) {
            actionReadyFired.current = true;
            onActionReady();
        }
    }, [
        chatMessages,
        onActionReady,
        activeRemixConversation?.status,
        isRemixCancelled
    ]);
    const stopRemixing = (0, $cozmU.useCallback)(()=>{
        abortRequests?.({
            conversationId: activeRemixConversation?.id
        });
    }, [
        abortRequests,
        activeRemixConversation?.id
    ]);
    const openAIFCStagingModal = (0, $cozmU.useCallback)((options)=>{
        // Chart/visualization previews can become ready after Rovo has already
        // deactivated the conversation. Do not let a stale completion callback
        // open an empty modal after the user stopped that exact Remix.
        if (isRemixCancelled) return;
        setForceSkipAutoConversationSelection(true);
        // Open the Confluence Smart Creation Modal with stagingAreaActive=true
        // to skip the prompt screen and go straight to the staging area preview.
        //
        // Only keep the ephemeral preview for remix-generated preview content.
        // The shared helper currently treats dynamic UI, image-based remix flows,
        // and remix-generated whiteboards/diagrams as ephemeral-preview candidates.
        // All other ACTION_PREPARE results should open the full AIFC modal.
        //
        // Pass forceFullModal: true to bypass this check
        const shouldUseEphemeralPreview = options?.forceFullModal ? false : $1e31de274ed01603$var$shouldOpenEphemeralPreview(chatMessages);
        openModal({
            entryPoint: 'dynamicUi',
            spaceKey: spaceKey ?? undefined,
            parentContent: contentId && !isDraftPage ? {
                id: contentId,
                title: contentTitle ?? '',
                contentType: contentType ?? 'page'
            } : undefined,
            stagingAreaActive: true,
            isFloating: shouldUseEphemeralPreview,
            shouldShowBackButton: false,
            ...activeRemixConversation?.id && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true) ? {
                remixConversationId: activeRemixConversation.id
            } : {},
            // `stagingAreaTargetMode` decides whether the current content is also
            // registered as staging-area content, or preserved only as parent/source
            // context for generated-content flows.
            ...stagingAreaTargetMode === 'current-content' && contentId ? {
                content: {
                    id: contentId,
                    type: contentType ?? 'page',
                    subType: isLivePage ? 'live' : null
                }
            } : {},
            // Pass a submitCallback only for ephemeral (floating) previews to
            // prevent navigating away from the current page. For the full modal flow
            // (e.g. "Add to Confluence"), omit the callback so the default
            // handleSubmitSmartCreate handler runs and redirects to the newly created content.
            ...shouldUseEphemeralPreview ? {
                submitCallback: async ()=>{
                    // Refresh the page tree for ephemeral previews only when the experiment is enabled.
                    if (!(0, $6mKj3.expVal)('cc-maui-refresh-page-tree-with-diagram', 'isEnabled', false)) return;
                    if (contentId) (0, $ficwO.publishMessage)((0, $ficwO.Message).PageTreeRefreshRequested, {
                        parentId: contentId
                    });
                }
            } : {},
            onOpenCallback: onPreviewOpened,
            onSubmitCallback: onSubmitted,
            onCloseCallback: onPreviewDismissed
        });
    }, [
        openModal,
        spaceKey,
        contentId,
        contentType,
        contentTitle,
        isLivePage,
        isDraftPage,
        activeRemixConversation?.id,
        isRemixCancelled,
        setForceSkipAutoConversationSelection,
        chatMessages,
        stagingAreaTargetMode,
        onPreviewOpened,
        onSubmitted,
        onPreviewDismissed
    ]);
    const sendAIFCPrompt = (0, $cozmU.useCallback)(async ({ userPrompt: userPrompt, promptText: promptTextOverride, dynamicUiSubtype: dynamicUiSubtype, dynamicUiType: dynamicUiType, dynamicUiSource: dynamicUiSource, interactionSource: interactionSource, forcedContentType: forcedContentType, additionalCreationContextParams: additionalCreationContextParams, conversationId: reuseConversationId })=>{
        const defaultPromptText = 'Remix the selected content';
        const selectedDisplayName = dynamicUiSubtype ? (0, $loej8.getSubTypeDisplayName)(dynamicUiSubtype) : (0, $loej8.getTypeDisplayName)(dynamicUiType);
        const autoText = `Remix the selected content as a ${selectedDisplayName}`;
        let promptText;
        if (promptTextOverride) promptText = promptTextOverride;
        else if (dynamicUiType === 'custom') promptText = userPrompt ?? defaultPromptText;
        else promptText = userPrompt ? `${autoText}. ${userPrompt}` : autoText;
        // Build the ADF DocNode prompt.
        const prompt = {
            type: 'doc',
            version: 1,
            content: [
                {
                    type: 'paragraph',
                    content: [
                        {
                            type: 'text',
                            text: promptText
                        }
                    ]
                }
            ]
        };
        const newConversationId = reuseConversationId ?? (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
        // Store the ID so we can identify this conversation as the active remix.
        setRemixConversationId(newConversationId);
        actionReadyFired.current = false;
        if (reuseConversationId && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-ce-maui-remix-menu-multivariant', 'cohort', 'variant2')) setSelectedConversation({
            conversationId: reuseConversationId
        });
        await createConversationOptimistically({
            id: newConversationId,
            ...shouldTrackRemixConversationById ? {
                isViewModeRemix: true
            } : {}
        });
        let creationContextExperienceParams = {};
        if (!additionalCreationContextParams) {
            if (dynamicUiType === 'custom') creationContextExperienceParams = {
                experience: 'remix_custom'
            };
            else creationContextExperienceParams = {
                experience: 'remix',
                blocks: [
                    dynamicUiType
                ]
            };
        }
        // Send the message to Rovo
        sendMessage({
            prompt: prompt,
            storeUserMessages: preferences.storeUserMessages,
            conversationId: newConversationId,
            messageSources: {
                interactionSource: interactionSource,
                // Use the same source for follow-ups: Remix doesn't have a separate follow-up entry point, but the "viewed" AIMAU analytics event uses `followUpSource`.
                followUpSource: interactionSource
            },
            productKey: 'confluence',
            contentContext: 'staging-area',
            creationContextParams: {
                dynamicUiType: dynamicUiType,
                dynamicUiSubtype: dynamicUiSubtype,
                dynamicUiSource: dynamicUiSource,
                source: 'remix',
                ...creationContextExperienceParams,
                ...forcedContentType ? {
                    forcedContentType: forcedContentType
                } : {},
                ...additionalCreationContextParams,
                ...dynamicUiType !== 'custom' && userPrompt ? {
                    hasUserInstruction: true
                } : {}
            }
        });
        // Store the prompt text for display in the staging area header.
        // Always show the brand keyword regardless of the user's custom prompt.
        // cc_maui_create_keyword: swap "Remix" -> "Create". Use the no-exposure variant since the
        // create-keyword exposure has already fired upstream when the remix flow was triggered.
        setPrompt((0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc_maui_create_keyword', 'isEnabled', true) ? 'Create' : 'Remix');
        // Persist the dynamic UI context so the update flow can use
        // the original type/source when sending remix adjustment messages
        setDynamicUiContext(dynamicUiType, dynamicUiSubtype, dynamicUiSource);
        // Keep the user's pick; setDynamicUiContext above gets overwritten with the
        // backend subtype on response, and EditWithRovoBar needs both to flag a mismatch.
        setUserSelectedDynamicUiSubtype(dynamicUiSubtype);
        setInteractionSource(interactionSource);
        return newConversationId;
    }, [
        createConversationOptimistically,
        sendMessage,
        setPrompt,
        setDynamicUiContext,
        setUserSelectedDynamicUiSubtype,
        setInteractionSource,
        setSelectedConversation,
        preferences.storeUserMessages,
        shouldTrackRemixConversationById
    ]);
    return {
        sendAIFCPrompt: sendAIFCPrompt,
        stopRemixing: stopRemixing,
        isRemixError: isRemixError,
        isRemixAborted: isRemixAborted,
        isRemixCancelled: isRemixCancelled,
        remixStoreError: remixStoreError,
        openAIFCStagingModal: openAIFCStagingModal,
        closeAIFCStagingModal: closeModal,
        remixConversationId: remixConversationId,
        resetRemixConversationId: resetRemixConversationId,
        setSelectedConversation: setSelectedConversation
    };
};
module.exports["useRemixToAIFC"] = $1e31de274ed01603$export$cca9e2432f59b3f8;

});

parcelRegister("ew8wg", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $duklN = parcelRequire("duklN");


var $cozmU = parcelRequire("cozmU");


var $1uFM6 = parcelRequire("1uFM6");


var $95rLf = parcelRequire("95rLf");


var $7Sm4c = parcelRequire("7Sm4c");


var $jMyy4 = parcelRequire("jMyy4");

const $df587a746afa9e84$export$4882d379d640c470 = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { contentId: contentId } = t0;
    let t1;
    if ($[0] !== contentId) {
        t1 = {
            variables: {
                contentId: contentId
            }
        };
        $[0] = contentId;
        $[1] = t1;
    } else t1 = $[1];
    const { data: data, error: error } = (0, $jMyy4.useQueryInterop)((0, $duklN.default), {
        ...t1,
        __callerPackage__: "content-title"
    });
    let t2;
    let t3;
    if ($[2] !== error) {
        t2 = ()=>{
            if (error && ((0, $1uFM6.isUnauthorizedError)(error) || (0, $95rLf.isExpectedApolloError)(error))) (0, $7Sm4c.markErrorAsHandled)(error);
        };
        t3 = [
            error
        ];
        $[2] = error;
        $[3] = t2;
        $[4] = t3;
    } else {
        t2 = $[3];
        t3 = $[4];
    }
    (0, $cozmU.useEffect)(t2, t3);
    const t4 = data?.singleContent?.title;
    let t5;
    if ($[5] !== error || $[6] !== t4) {
        t5 = {
            title: t4,
            error: error
        };
        $[5] = error;
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    return t5;
};
module.exports["usePageTitle"] = $df587a746afa9e84$export$4882d379d640c470;

});


//# sourceMappingURL=CommentEditor.4a866a73.js.map
